"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               v5.29.3
// source: property/provider.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.Provider = exports.protobufPackage = void 0;
exports.providerFromJSON = providerFromJSON;
exports.providerToJSON = providerToJSON;
/* eslint-disable */
exports.protobufPackage = "property";
/**
 * Provider represents the real estate board that provides property listing data.
 * Each provider has a unique identifier and represents a specific geographic region or market.
 */
var Provider;
(function (Provider) {
    Provider[Provider["PROVIDER_UNSPECIFIED"] = 0] = "PROVIDER_UNSPECIFIED";
    Provider[Provider["PROVIDER_VREB_IDX"] = 30005] = "PROVIDER_VREB_IDX";
    Provider[Provider["PROVIDER_LDON_IDX"] = 30010] = "PROVIDER_LDON_IDX";
    Provider[Provider["PROVIDER_NSAR_IDX"] = 30003] = "PROVIDER_NSAR_IDX";
    Provider[Provider["PROVIDER_NSAR_VOW"] = 30004] = "PROVIDER_NSAR_VOW";
    Provider[Provider["PROVIDER_ALB_IDX"] = 30006] = "PROVIDER_ALB_IDX";
    Provider[Provider["PROVIDER_CREB_IDX"] = 30012] = "PROVIDER_CREB_IDX";
    Provider[Provider["PROVIDER_BRC_IDX"] = 30008] = "PROVIDER_BRC_IDX";
    Provider[Provider["PROVIDER_TREB_VOW"] = 30000] = "PROVIDER_TREB_VOW";
    Provider[Provider["PROVIDER_TREB_IDX"] = 30001] = "PROVIDER_TREB_IDX";
    Provider[Provider["PROVIDER_RAHB_IDX"] = 30007] = "PROVIDER_RAHB_IDX";
    Provider[Provider["PROVIDER_ITSO_IDX"] = 30009] = "PROVIDER_ITSO_IDX";
    Provider[Provider["PROVIDER_OREB_VOW"] = 30011] = "PROVIDER_OREB_VOW";
    Provider[Provider["PROVIDER_CREA_DDF"] = 30002] = "PROVIDER_CREA_DDF";
    Provider[Provider["PROVIDER_ITSO_VOW"] = 31013] = "PROVIDER_ITSO_VOW";
    Provider[Provider["PROVIDER_PILLAR9_IDX"] = 31014] = "PROVIDER_PILLAR9_IDX";
    Provider[Provider["PROVIDER_PILLAR9_VOW"] = 31015] = "PROVIDER_PILLAR9_VOW";
    Provider[Provider["PROVIDER_REBGV_IDX"] = 31016] = "PROVIDER_REBGV_IDX";
    Provider[Provider["PROVIDER_REBGV_VOW"] = 31017] = "PROVIDER_REBGV_VOW";
    Provider[Provider["PROVIDER_STELLAR_MLS_IDX"] = 31018] = "PROVIDER_STELLAR_MLS_IDX";
    Provider[Provider["PROVIDER_MIAMI_SEF_IDX_PLUS"] = 31019] = "PROVIDER_MIAMI_SEF_IDX_PLUS";
    Provider[Provider["PROVIDER_BRIGHT_MLS"] = 31020] = "PROVIDER_BRIGHT_MLS";
    Provider[Provider["PROVIDER_ABERDEEN_BOARD_OF_REALTORS"] = 31021] = "PROVIDER_ABERDEEN_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_ADIRONDACK_CHAMPLAIN_VALLEY_MLS"] = 31022] = "PROVIDER_ADIRONDACK_CHAMPLAIN_VALLEY_MLS";
    Provider[Provider["PROVIDER_AIKEN_MLS"] = 31023] = "PROVIDER_AIKEN_MLS";
    Provider[Provider["PROVIDER_ALAMANCE_MULTIPLE_LISTING_SERVICE"] = 31024] = "PROVIDER_ALAMANCE_MULTIPLE_LISTING_SERVICE";
    Provider[Provider["PROVIDER_ALASKA_MULTIPLE_LISTING_SERVICE"] = 31025] = "PROVIDER_ALASKA_MULTIPLE_LISTING_SERVICE";
    Provider[Provider["PROVIDER_ALLEGHENY_HIGHLAND_ASSOCIATION_OF_REALTORS"] = 31026] = "PROVIDER_ALLEGHENY_HIGHLAND_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_AMELIA_ISLANDUNDEFINED_NASSAU_COUNTY_ASSOCIATION_OF_REALTORS"] = 31027] = "PROVIDER_AMELIA_ISLANDUNDEFINED_NASSAU_COUNTY_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_ARIZONA_REGIONAL_MULTIPLE_LISTING_SERVICE"] = 31028] = "PROVIDER_ARIZONA_REGIONAL_MULTIPLE_LISTING_SERVICE";
    Provider[Provider["PROVIDER_ARIZONA_REGIONAL_MULTIPLE_LISTING_SERVICE_EXP_PORTAL_ONLY"] = 31029] = "PROVIDER_ARIZONA_REGIONAL_MULTIPLE_LISTING_SERVICE_EXP_PORTAL_ONLY";
    Provider[Provider["PROVIDER_ASHLAND_AREA_BOARD_OF_REALTORS"] = 31030] = "PROVIDER_ASHLAND_AREA_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_ASHLAND_BOARD_OF_REALTORS"] = 31031] = "PROVIDER_ASHLAND_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_ASPEN_GLENWOOD_MLS"] = 31032] = "PROVIDER_ASPEN_GLENWOOD_MLS";
    Provider[Provider["PROVIDER_ASSOCIATED_MULTILIST_SERVICES_OF_OKLAHOMA"] = 31033] = "PROVIDER_ASSOCIATED_MULTILIST_SERVICES_OF_OKLAHOMA";
    Provider[Provider["PROVIDER_ATHENS_AREA_ASSOCIATION_OF_REALTORS"] = 31034] = "PROVIDER_ATHENS_AREA_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_ATHENS_COUNTY_BOARD_OF_REALTORS"] = 31035] = "PROVIDER_ATHENS_COUNTY_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_AUSTIN_CENTRAL_TEXAS_REALTY_INFORMATION_SERVICE"] = 31036] = "PROVIDER_AUSTIN_CENTRAL_TEXAS_REALTY_INFORMATION_SERVICE";
    Provider[Provider["PROVIDER_BADLANDS_BOARD_OF_REALTORS_INC_MLS"] = 31037] = "PROVIDER_BADLANDS_BOARD_OF_REALTORS_INC_MLS";
    Provider[Provider["PROVIDER_BAKERSFIELD_ASSOCIATION_OF_REALTORS"] = 31038] = "PROVIDER_BAKERSFIELD_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_BALDWIN_REALTORS"] = 31039] = "PROVIDER_BALDWIN_REALTORS";
    Provider[Provider["PROVIDER_BAY_AREA_REAL_ESTATE_INFORMATION_SERVICES_INC"] = 31040] = "PROVIDER_BAY_AREA_REAL_ESTATE_INFORMATION_SERVICES_INC";
    Provider[Provider["PROVIDER_BEACHES_MLS"] = 31041] = "PROVIDER_BEACHES_MLS";
    Provider[Provider["PROVIDER_BEACHES_MLS_EXP_PORTAL_ONLY"] = 31042] = "PROVIDER_BEACHES_MLS_EXP_PORTAL_ONLY";
    Provider[Provider["PROVIDER_BEAUMONT_BOARD_OF_REALTORS_INC_MLS"] = 31043] = "PROVIDER_BEAUMONT_BOARD_OF_REALTORS_INC_MLS";
    Provider[Provider["PROVIDER_BERKSHIRE_COUNTY_BOARD_OF_REALTORS"] = 31044] = "PROVIDER_BERKSHIRE_COUNTY_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_BIG_SKY_COUNTRY_MLS"] = 31045] = "PROVIDER_BIG_SKY_COUNTRY_MLS";
    Provider[Provider["PROVIDER_BILLINGS_ASSOCIATION_OF_REALTORS"] = 31046] = "PROVIDER_BILLINGS_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_BILLINGS_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY"] = 31047] = "PROVIDER_BILLINGS_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY";
    Provider[Provider["PROVIDER_BISMARCK_MANDAN_BOARD_OF_REALTORS"] = 31048] = "PROVIDER_BISMARCK_MANDAN_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_BLACK_HILLS_ASSOCIATION_OF_REALTORS"] = 31049] = "PROVIDER_BLACK_HILLS_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_BLUEGRASS_REALTORS"] = 31050] = "PROVIDER_BLUEGRASS_REALTORS";
    Provider[Provider["PROVIDER_BONITA_SPRINGS_ESTERO_ASSOCIATION_OF_REALTORS"] = 31051] = "PROVIDER_BONITA_SPRINGS_ESTERO_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_BRASIL"] = 31052] = "PROVIDER_BRASIL";
    Provider[Provider["PROVIDER_BRAZORIA_COUNTY_BOARD_OF_REALTORS"] = 31053] = "PROVIDER_BRAZORIA_COUNTY_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_BROOKLYN_NEW_YORK_MLS"] = 31054] = "PROVIDER_BROOKLYN_NEW_YORK_MLS";
    Provider[Provider["PROVIDER_BRUNSWICK_COUNTY_MLS"] = 31055] = "PROVIDER_BRUNSWICK_COUNTY_MLS";
    Provider[Provider["PROVIDER_BRYANCOLLEGE_STATION_REGIONAL_MLS"] = 31056] = "PROVIDER_BRYANCOLLEGE_STATION_REGIONAL_MLS";
    Provider[Provider["PROVIDER_CALAVERAS_COUNTY_ASSOCIATION_OF_REALTORS"] = 31057] = "PROVIDER_CALAVERAS_COUNTY_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_CALIFORNIA_REGIONAL_MULTIPLE_LISTING_SERVICE"] = 31058] = "PROVIDER_CALIFORNIA_REGIONAL_MULTIPLE_LISTING_SERVICE";
    Provider[Provider["PROVIDER_CAMBRIA_SOMERSET_ASSOCIATION_OF_REALTORS"] = 31059] = "PROVIDER_CAMBRIA_SOMERSET_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_CANOPY_MLS"] = 31060] = "PROVIDER_CANOPY_MLS";
    Provider[Provider["PROVIDER_CAPE_CODUNDEFINED_ISLANDS_ASSOCIATION_OF_REALTORS"] = 31061] = "PROVIDER_CAPE_CODUNDEFINED_ISLANDS_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_CAPE_FEAR_REALTORS"] = 31062] = "PROVIDER_CAPE_FEAR_REALTORS";
    Provider[Provider["PROVIDER_CAPE_MAY_COUNTY_ASSOCIATION_OF_REALTORS"] = 31063] = "PROVIDER_CAPE_MAY_COUNTY_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_CAPITAL_AREA_TECHNOLOGY_REALTOR_SERVICES"] = 31064] = "PROVIDER_CAPITAL_AREA_TECHNOLOGY_REALTOR_SERVICES";
    Provider[Provider["PROVIDER_CARPET_CAPITAL_ASSOCIATION_OF_REALTORS"] = 31065] = "PROVIDER_CARPET_CAPITAL_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_CARPET_CAPITAL_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY"] = 31066] = "PROVIDER_CARPET_CAPITAL_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY";
    Provider[Provider["PROVIDER_CARTERET_COUNTY_ASSOCIATION_OF_REALTORS"] = 31067] = "PROVIDER_CARTERET_COUNTY_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_CEDAR_RAPIDS_AREA_ASSOCIATION_OF_REALTORS"] = 31068] = "PROVIDER_CEDAR_RAPIDS_AREA_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_CENTRAL_GEORGIA_MLS"] = 31069] = "PROVIDER_CENTRAL_GEORGIA_MLS";
    Provider[Provider["PROVIDER_CENTRAL_GEORGIA_MLS_EXP_PORTAL_ONLY"] = 31070] = "PROVIDER_CENTRAL_GEORGIA_MLS_EXP_PORTAL_ONLY";
    Provider[Provider["PROVIDER_CENTRAL_HILL_COUNTRY_BOARD_OF_REALTORS"] = 31071] = "PROVIDER_CENTRAL_HILL_COUNTRY_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_CENTRAL_ILLINOIS_BOARD_OF_REALTORS"] = 31072] = "PROVIDER_CENTRAL_ILLINOIS_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_CENTRAL_JERSEY_MULTIPLE_LISTING_SYSTEM_INC"] = 31073] = "PROVIDER_CENTRAL_JERSEY_MULTIPLE_LISTING_SYSTEM_INC";
    Provider[Provider["PROVIDER_CENTRAL_MISSISSIPPI_MLS"] = 31074] = "PROVIDER_CENTRAL_MISSISSIPPI_MLS";
    Provider[Provider["PROVIDER_CENTRAL_PANHANDLE_ASSOCIATION_OF_REALTORS"] = 31075] = "PROVIDER_CENTRAL_PANHANDLE_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_CENTRAL_SUSQUEHANNA_VALLEY_BOARD_OF_REALTORS"] = 31076] = "PROVIDER_CENTRAL_SUSQUEHANNA_VALLEY_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_CENTRAL_TEXAS_MULTIPLE_LISTING_SERVICE"] = 31077] = "PROVIDER_CENTRAL_TEXAS_MULTIPLE_LISTING_SERVICE";
    Provider[Provider["PROVIDER_CENTRAL_VIRGINIA_REGIONAL_MULTIPLE_LISTING_SERVICE"] = 31078] = "PROVIDER_CENTRAL_VIRGINIA_REGIONAL_MULTIPLE_LISTING_SERVICE";
    Provider[Provider["PROVIDER_CENTRAL_WEST_TENNESSEE_ASSOCIATION_OF_REALTORS"] = 31079] = "PROVIDER_CENTRAL_WEST_TENNESSEE_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_CENTRAL_WISCONSIN_MLS"] = 31080] = "PROVIDER_CENTRAL_WISCONSIN_MLS";
    Provider[Provider["PROVIDER_CHARLOTTESVILLE_AREA_ASSOCIATION_OF_REALTORS"] = 31081] = "PROVIDER_CHARLOTTESVILLE_AREA_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_CHS_REGIONAL_MLS"] = 31082] = "PROVIDER_CHS_REGIONAL_MLS";
    Provider[Provider["PROVIDER_CLATSOP_ASSOCIATION_OF_REALTORS"] = 31083] = "PROVIDER_CLATSOP_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_CLEARFIELDJEFFERSON_ASSOCIATION_OF_REALTORS"] = 31084] = "PROVIDER_CLEARFIELDJEFFERSON_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_COASTAL_CAROLINA_ASSOCIATION_OF_REALTORS"] = 31085] = "PROVIDER_COASTAL_CAROLINA_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_COEUR_DALENE_MULTIPLE_LISTING_SERVICE"] = 31086] = "PROVIDER_COEUR_DALENE_MULTIPLE_LISTING_SERVICE";
    Provider[Provider["PROVIDER_COLORADO_REAL_ESTATE_NETWORK_INC"] = 31087] = "PROVIDER_COLORADO_REAL_ESTATE_NETWORK_INC";
    Provider[Provider["PROVIDER_COLUMBIA"] = 31088] = "PROVIDER_COLUMBIA";
    Provider[Provider["PROVIDER_COLUMBIA_BOARD_OF_REALTORS"] = 31089] = "PROVIDER_COLUMBIA_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_COLUMBIA_GREENE_AND_NORTHERN_DUTCHESS_MLS"] = 31090] = "PROVIDER_COLUMBIA_GREENE_AND_NORTHERN_DUTCHESS_MLS";
    Provider[Provider["PROVIDER_COLUMBUS_AND_CENTRAL_OHIO_MULTIPLE_LISTING_SERVICE"] = 31091] = "PROVIDER_COLUMBUS_AND_CENTRAL_OHIO_MULTIPLE_LISTING_SERVICE";
    Provider[Provider["PROVIDER_COLUMBUS_BOARD_OF_REALTORS"] = 31092] = "PROVIDER_COLUMBUS_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_CONSOLIDATED_MLS_INC"] = 31093] = "PROVIDER_CONSOLIDATED_MLS_INC";
    Provider[Provider["PROVIDER_CONTRA_COSTA_AOR_BAY_EAST_AOR_AND_BRIDGE_MLS"] = 31094] = "PROVIDER_CONTRA_COSTA_AOR_BAY_EAST_AOR_AND_BRIDGE_MLS";
    Provider[Provider["PROVIDER_COOPERATIVE_ARKANSAS_REALTORS_MULTIPLE_LISTING_SERVICE"] = 31095] = "PROVIDER_COOPERATIVE_ARKANSAS_REALTORS_MULTIPLE_LISTING_SERVICE";
    Provider[Provider["PROVIDER_CORPUS_CHRISTI_ASSOCIATION_OF_REALTORS"] = 31096] = "PROVIDER_CORPUS_CHRISTI_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_CREA"] = 31097] = "PROVIDER_CREA";
    Provider[Provider["PROVIDER_DAYTONA_BEACH_AREA_ASSOCIATION_OF_REALTORS"] = 31098] = "PROVIDER_DAYTONA_BEACH_AREA_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_DAYTON_REALTORS_MLS"] = 31099] = "PROVIDER_DAYTON_REALTORS_MLS";
    Provider[Provider["PROVIDER_DEMO_MLS"] = 31100] = "PROVIDER_DEMO_MLS";
    Provider[Provider["PROVIDER_DES_MOINES_AREA_ASSOCIATION_OF_REALTORS_INC"] = 31101] = "PROVIDER_DES_MOINES_AREA_ASSOCIATION_OF_REALTORS_INC";
    Provider[Provider["PROVIDER_DIXIE_GILCHRIST_LEVY_COUNTIES_BOARD_OF_REALTORS"] = 31102] = "PROVIDER_DIXIE_GILCHRIST_LEVY_COUNTIES_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_DOMINICAN_REPUBLIC"] = 31103] = "PROVIDER_DOMINICAN_REPUBLIC";
    Provider[Provider["PROVIDER_DUBLIN_BOARD_OF_REALTORS"] = 31104] = "PROVIDER_DUBLIN_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_DUMMY_MLS_FOR_QA"] = 31105] = "PROVIDER_DUMMY_MLS_FOR_QA";
    Provider[Provider["PROVIDER_ELKO_COUNTY_BOARD_OF_REALTORS"] = 31106] = "PROVIDER_ELKO_COUNTY_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_ELMIRACORNING_REGIONAL_BOARD_OF_REALTORS_MLS"] = 31107] = "PROVIDER_ELMIRACORNING_REGIONAL_BOARD_OF_REALTORS_MLS";
    Provider[Provider["PROVIDER_EMERALD_COAST_ASSOCIATION_OF_REALTORS"] = 31108] = "PROVIDER_EMERALD_COAST_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_EMERALD_COAST_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY"] = 31109] = "PROVIDER_EMERALD_COAST_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY";
    Provider[Provider["PROVIDER_EXP_PORTAL1"] = 31110] = "PROVIDER_EXP_PORTAL1";
    Provider[Provider["PROVIDER_EXP_PORTAL10"] = 31111] = "PROVIDER_EXP_PORTAL10";
    Provider[Provider["PROVIDER_EXP_PORTAL11"] = 31112] = "PROVIDER_EXP_PORTAL11";
    Provider[Provider["PROVIDER_EXP_PORTAL12"] = 31113] = "PROVIDER_EXP_PORTAL12";
    Provider[Provider["PROVIDER_EXP_PORTAL13"] = 31114] = "PROVIDER_EXP_PORTAL13";
    Provider[Provider["PROVIDER_EXP_PORTAL14"] = 31115] = "PROVIDER_EXP_PORTAL14";
    Provider[Provider["PROVIDER_EXP_PORTAL15"] = 31116] = "PROVIDER_EXP_PORTAL15";
    Provider[Provider["PROVIDER_EXP_PORTAL18"] = 31117] = "PROVIDER_EXP_PORTAL18";
    Provider[Provider["PROVIDER_EXP_PORTAL19"] = 31118] = "PROVIDER_EXP_PORTAL19";
    Provider[Provider["PROVIDER_EXP_PORTAL2"] = 31119] = "PROVIDER_EXP_PORTAL2";
    Provider[Provider["PROVIDER_EXP_PORTAL20"] = 31120] = "PROVIDER_EXP_PORTAL20";
    Provider[Provider["PROVIDER_EXP_PORTAL21"] = 31121] = "PROVIDER_EXP_PORTAL21";
    Provider[Provider["PROVIDER_EXP_PORTAL22"] = 31122] = "PROVIDER_EXP_PORTAL22";
    Provider[Provider["PROVIDER_EXP_PORTAL23"] = 31123] = "PROVIDER_EXP_PORTAL23";
    Provider[Provider["PROVIDER_EXP_PORTAL24_SMART"] = 31124] = "PROVIDER_EXP_PORTAL24_SMART";
    Provider[Provider["PROVIDER_EXP_PORTAL24_CR_MLS"] = 31125] = "PROVIDER_EXP_PORTAL24_CR_MLS";
    Provider[Provider["PROVIDER_EXP_PORTAL3"] = 31126] = "PROVIDER_EXP_PORTAL3";
    Provider[Provider["PROVIDER_EXP_PORTAL4"] = 31127] = "PROVIDER_EXP_PORTAL4";
    Provider[Provider["PROVIDER_EXP_PORTAL5"] = 31128] = "PROVIDER_EXP_PORTAL5";
    Provider[Provider["PROVIDER_EXP_PORTAL6"] = 31129] = "PROVIDER_EXP_PORTAL6";
    Provider[Provider["PROVIDER_EXP_PORTAL7"] = 31130] = "PROVIDER_EXP_PORTAL7";
    Provider[Provider["PROVIDER_EXP_PORTAL8"] = 31131] = "PROVIDER_EXP_PORTAL8";
    Provider[Provider["PROVIDER_EXP_PORTAL9"] = 31132] = "PROVIDER_EXP_PORTAL9";
    Provider[Provider["PROVIDER_FARGO_MOORHEAD_AREA_ASSOCIATION_OF_REALTORS"] = 31133] = "PROVIDER_FARGO_MOORHEAD_AREA_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_FIRELANDS_MLS"] = 31134] = "PROVIDER_FIRELANDS_MLS";
    Provider[Provider["PROVIDER_FIRST_MULTIPLE_LISTING_SERVICE"] = 31135] = "PROVIDER_FIRST_MULTIPLE_LISTING_SERVICE";
    Provider[Provider["PROVIDER_FLINT_HILLS_ASSOCIATION_OF_REALTORS"] = 31136] = "PROVIDER_FLINT_HILLS_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_FLORIDA_KEYS_BOARD_OF_REALTORS"] = 31137] = "PROVIDER_FLORIDA_KEYS_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_FORT_DODGE_MLS"] = 31138] = "PROVIDER_FORT_DODGE_MLS";
    Provider[Provider["PROVIDER_FRANCE"] = 31139] = "PROVIDER_FRANCE";
    Provider[Provider["PROVIDER_FRESNO_MLS"] = 31140] = "PROVIDER_FRESNO_MLS";
    Provider[Provider["PROVIDER_GALVESTON_ASSOCIATION_OF_REALTORS_MLS"] = 31141] = "PROVIDER_GALVESTON_ASSOCIATION_OF_REALTORS_MLS";
    Provider[Provider["PROVIDER_GARDEN_STATE_MLS"] = 31142] = "PROVIDER_GARDEN_STATE_MLS";
    Provider[Provider["PROVIDER_GARDEN_STATE_MLS_EXP_PORTAL_ONLY"] = 31143] = "PROVIDER_GARDEN_STATE_MLS_EXP_PORTAL_ONLY";
    Provider[Provider["PROVIDER_GEORGIA_MULTIPLE_LISTING_SERVICE"] = 31144] = "PROVIDER_GEORGIA_MULTIPLE_LISTING_SERVICE";
    Provider[Provider["PROVIDER_GERMANY"] = 31145] = "PROVIDER_GERMANY";
    Provider[Provider["PROVIDER_GLOBAL_MLS_INC"] = 31146] = "PROVIDER_GLOBAL_MLS_INC";
    Provider[Provider["PROVIDER_GOLDSBORO_WAYNE_COUNTY_ASSOCIATION_OF_REALTORS"] = 31147] = "PROVIDER_GOLDSBORO_WAYNE_COUNTY_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_GRAND_COUNTY_BOARD_OF_REALTORS"] = 31148] = "PROVIDER_GRAND_COUNTY_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_GRAND_ISLAND_BOARD_OF_REALTORS"] = 31149] = "PROVIDER_GRAND_ISLAND_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_GRAND_JUNCTION_AREA_REALTORS_ASSOCIATION_MLS"] = 31150] = "PROVIDER_GRAND_JUNCTION_AREA_REALTORS_ASSOCIATION_MLS";
    Provider[Provider["PROVIDER_GREATER_ALABAMA_MLS"] = 31151] = "PROVIDER_GREATER_ALABAMA_MLS";
    Provider[Provider["PROVIDER_GREATER_ANTELOPE_VALLEY_ASSOCIATION_OF_REALTORS"] = 31152] = "PROVIDER_GREATER_ANTELOPE_VALLEY_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_GREATER_AUGUSTA_ASSOCIATION_OF_REALTORS"] = 31153] = "PROVIDER_GREATER_AUGUSTA_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_GREATER_BATON_ROUGE_ASSOCIATION_OF_REALTORS"] = 31154] = "PROVIDER_GREATER_BATON_ROUGE_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_GREATER_CHATTANOOGA_ASSOCIATION_OF_REALTORS"] = 31155] = "PROVIDER_GREATER_CHATTANOOGA_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_GREATER_CHATTANOOGA_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY"] = 31156] = "PROVIDER_GREATER_CHATTANOOGA_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY";
    Provider[Provider["PROVIDER_GREATER_EL_PASO_ASSOCIATION_OF_REALTORS"] = 31157] = "PROVIDER_GREATER_EL_PASO_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_GREATER_ERIE_BOARD_OF_REALTORS_MLS"] = 31158] = "PROVIDER_GREATER_ERIE_BOARD_OF_REALTORS_MLS";
    Provider[Provider["PROVIDER_GREATER_GREENVILLE_ASSOCIATION_OF_REALTORS"] = 31159] = "PROVIDER_GREATER_GREENVILLE_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_GREATER_LAS_VEGAS_ASSOCIATION_OF_REALTORS_INC"] = 31160] = "PROVIDER_GREATER_LAS_VEGAS_ASSOCIATION_OF_REALTORS_INC";
    Provider[Provider["PROVIDER_GREATER_LEHIGH_VALLEY_REALTORS"] = 31161] = "PROVIDER_GREATER_LEHIGH_VALLEY_REALTORS";
    Provider[Provider["PROVIDER_GREATER_LOUISVILLE_ASSOCIATION_OF_REALTORS"] = 31162] = "PROVIDER_GREATER_LOUISVILLE_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_GREATER_MASON_CITY_BOARD_OF_REALTORS"] = 31163] = "PROVIDER_GREATER_MASON_CITY_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_GREATER_MCALLEN_ASSOCIATION_OF_REALTORS"] = 31164] = "PROVIDER_GREATER_MCALLEN_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_GREATER_REGIONAL_ASSOCIATION_OF_REALTORS"] = 31411] = "PROVIDER_GREATER_REGIONAL_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_GREATER_NORTHWEST_INDIANA_ASSOCIATION_OF_REALTORS"] = 31165] = "PROVIDER_GREATER_NORTHWEST_INDIANA_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_GREATER_OWENSBORO_REALTOR_ASSOCIATION"] = 31166] = "PROVIDER_GREATER_OWENSBORO_REALTOR_ASSOCIATION";
    Provider[Provider["PROVIDER_GREATER_PORTSMOUTH_AREA_MULTIPLE_LISTING_SERVICE"] = 31167] = "PROVIDER_GREATER_PORTSMOUTH_AREA_MULTIPLE_LISTING_SERVICE";
    Provider[Provider["PROVIDER_GREATER_SOUTHERN_MLS"] = 31168] = "PROVIDER_GREATER_SOUTHERN_MLS";
    Provider[Provider["PROVIDER_GREATER_TYLER_ASSOCIATION_OF_REALTORS"] = 31169] = "PROVIDER_GREATER_TYLER_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_GREATER_TYLER_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY"] = 31170] = "PROVIDER_GREATER_TYLER_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY";
    Provider[Provider["PROVIDER_GREAT_PLAINS_REGIONAL_MLS"] = 31171] = "PROVIDER_GREAT_PLAINS_REGIONAL_MLS";
    Provider[Provider["PROVIDER_GREAT_SMOKY_MOUNTAINS_ASSOCIATION_OF_REALTORS"] = 31172] = "PROVIDER_GREAT_SMOKY_MOUNTAINS_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_GREECE"] = 31173] = "PROVIDER_GREECE";
    Provider[Provider["PROVIDER_GREENVILLEPITT_ASSOCIATION_OF_REALTORS_MLS"] = 31174] = "PROVIDER_GREENVILLEPITT_ASSOCIATION_OF_REALTORS_MLS";
    Provider[Provider["PROVIDER_GREENWICH_ASSOCIATION_OF_REALTORS"] = 31175] = "PROVIDER_GREENWICH_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_GULF_COAST_MULTIPLE_LISTING_SERVICE"] = 31176] = "PROVIDER_GULF_COAST_MULTIPLE_LISTING_SERVICE";
    Provider[Provider["PROVIDER_GULF_SOUTH_REAL_ESTATE_INFORMATION_NETWORK"] = 31177] = "PROVIDER_GULF_SOUTH_REAL_ESTATE_INFORMATION_NETWORK";
    Provider[Provider["PROVIDER_HATTIESBURG_AREA_ASSOCIATION_OF_REALTORS"] = 31178] = "PROVIDER_HATTIESBURG_AREA_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_HAWAII_INFORMATION_SERVICE"] = 31179] = "PROVIDER_HAWAII_INFORMATION_SERVICE";
    Provider[Provider["PROVIDER_HEARTLAND_ASSOCIATION_OF_REALTORS"] = 31180] = "PROVIDER_HEARTLAND_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_HEARTLAND_MLS"] = 31181] = "PROVIDER_HEARTLAND_MLS";
    Provider[Provider["PROVIDER_HEART_OF_KENTUCKY_ASSOCIATION_OF_REALTORS"] = 31182] = "PROVIDER_HEART_OF_KENTUCKY_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_HERNANDO_COUNTY_ASSOCIATION_OF_REALTORS"] = 31183] = "PROVIDER_HERNANDO_COUNTY_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_HIGH_COUNTRY_ASSOCIATION_OF_REALTORS"] = 31184] = "PROVIDER_HIGH_COUNTRY_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_HIGHLAND_LAKES_ASSOCIATION_OF_REALTORS_MLS"] = 31185] = "PROVIDER_HIGHLAND_LAKES_ASSOCIATION_OF_REALTORS_MLS";
    Provider[Provider["PROVIDER_HIGHLANDS_CASHIERS_BOARD_OF_REALTORS"] = 31186] = "PROVIDER_HIGHLANDS_CASHIERS_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_HINESVILLE_AREA_BOARD_OF_REALTORS_INC_MLS"] = 31187] = "PROVIDER_HINESVILLE_AREA_BOARD_OF_REALTORS_INC_MLS";
    Provider[Provider["PROVIDER_HONOLULU_BOARD_OF_REALTORS"] = 31188] = "PROVIDER_HONOLULU_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_HONOLULU_BOARD_OF_REALTORS_EXP"] = 31189] = "PROVIDER_HONOLULU_BOARD_OF_REALTORS_EXP";
    Provider[Provider["PROVIDER_HOPKINSVILLE_CHRISTIAN_COUNTY_BOARD_OF_REALTORS"] = 31190] = "PROVIDER_HOPKINSVILLE_CHRISTIAN_COUNTY_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_HOT_SPRINGS_BOARD_OF_REALTORS"] = 31191] = "PROVIDER_HOT_SPRINGS_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_HOUSTON_REALTORS_INFORMATION_SERVICE"] = 31192] = "PROVIDER_HOUSTON_REALTORS_INFORMATION_SERVICE";
    Provider[Provider["PROVIDER_HUDSON_COUNTY_MULTIPLE_LISTING_SERVICE"] = 31193] = "PROVIDER_HUDSON_COUNTY_MULTIPLE_LISTING_SERVICE";
    Provider[Provider["PROVIDER_HUMBOLDT_COUNTY_MLS"] = 31194] = "PROVIDER_HUMBOLDT_COUNTY_MLS";
    Provider[Provider["PROVIDER_INCLINE_VILLAGE_BOARD_OF_REALTORS"] = 31195] = "PROVIDER_INCLINE_VILLAGE_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_INDIA"] = 31196] = "PROVIDER_INDIA";
    Provider[Provider["PROVIDER_INDIANA_REGIONAL_MLS"] = 31197] = "PROVIDER_INDIANA_REGIONAL_MLS";
    Provider[Provider["PROVIDER_INFORMATION_AND_REAL_ESTATE_SERVICES"] = 31198] = "PROVIDER_INFORMATION_AND_REAL_ESTATE_SERVICES";
    Provider[Provider["PROVIDER_INTERMOUNTAIN_MULTIPLE_LISTING_SERVICE"] = 31199] = "PROVIDER_INTERMOUNTAIN_MULTIPLE_LISTING_SERVICE";
    Provider[Provider["PROVIDER_IOWA_ASSOCIATION_OF_REALTORS"] = 31200] = "PROVIDER_IOWA_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_IOWA_GREAT_LAKES_BOARD_OF_REALTORS"] = 31201] = "PROVIDER_IOWA_GREAT_LAKES_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_ISRAEL"] = 31202] = "PROVIDER_ISRAEL";
    Provider[Provider["PROVIDER_ITALY"] = 31203] = "PROVIDER_ITALY";
    Provider[Provider["PROVIDER_JACKSONVILLE_BOARD_OF_REALTORS_NC"] = 31204] = "PROVIDER_JACKSONVILLE_BOARD_OF_REALTORS_NC";
    Provider[Provider["PROVIDER_JEFFERSON_CITY_AREA_BOARD_OF_REALTORS"] = 31205] = "PROVIDER_JEFFERSON_CITY_AREA_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_KANAB_UT_MLS"] = 31206] = "PROVIDER_KANAB_UT_MLS";
    Provider[Provider["PROVIDER_KANAWHA_VALLEY_BOARD_OF_REALTORS"] = 31207] = "PROVIDER_KANAWHA_VALLEY_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_KEY_WEST_ASSOCIATION_OF_REALTORS_MLS"] = 31208] = "PROVIDER_KEY_WEST_ASSOCIATION_OF_REALTORS_MLS";
    Provider[Provider["PROVIDER_KNOXVILLE_AREA_ASSOCIATION_OF_REALTORS"] = 31209] = "PROVIDER_KNOXVILLE_AREA_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_LAKE_COUNTRY_BOARD_OF_REALTORS"] = 31210] = "PROVIDER_LAKE_COUNTRY_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_LAKE_HAVASU_ASSOCIATION_MLS"] = 31211] = "PROVIDER_LAKE_HAVASU_ASSOCIATION_MLS";
    Provider[Provider["PROVIDER_LAKE_SUPERIOR_AREA_REALTORS"] = 31212] = "PROVIDER_LAKE_SUPERIOR_AREA_REALTORS";
    Provider[Provider["PROVIDER_LAKEWAY_AREA_ASSOCIATION_OF_REALTORS"] = 31213] = "PROVIDER_LAKEWAY_AREA_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_LAWRENCE_BOARD_OF_REALTORS"] = 31214] = "PROVIDER_LAWRENCE_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_LEE_COUNTY_ASSOCIATION_OF_REALTORS"] = 31215] = "PROVIDER_LEE_COUNTY_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_LINCOLN_COUNTY_BOARD_OF_REALTORS"] = 31216] = "PROVIDER_LINCOLN_COUNTY_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_LONGLEAF_PINE_REALTORS"] = 31217] = "PROVIDER_LONGLEAF_PINE_REALTORS";
    Provider[Provider["PROVIDER_LONGVIEW_AREA_ASSOCIATION_OF_REALTORS"] = 31218] = "PROVIDER_LONGVIEW_AREA_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_LOWCOUNTRY_REGIONAL_MULTIPLE_LISTING_SERVICE_INC"] = 31219] = "PROVIDER_LOWCOUNTRY_REGIONAL_MULTIPLE_LISTING_SERVICE_INC";
    Provider[Provider["PROVIDER_LUBBOCK_ASSOCIATION_OF_REALTORS"] = 31220] = "PROVIDER_LUBBOCK_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_LYNCHBURG_VIRGINIA_MLS"] = 31221] = "PROVIDER_LYNCHBURG_VIRGINIA_MLS";
    Provider[Provider["PROVIDER_MAINE_REAL_ESTATE_INFORMATION_SYSTEM_INC"] = 31222] = "PROVIDER_MAINE_REAL_ESTATE_INFORMATION_SYSTEM_INC";
    Provider[Provider["PROVIDER_MANSFIELD_ASSOCIATION_OF_REALTORS"] = 31223] = "PROVIDER_MANSFIELD_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_MARCO_ISLAND_AREA_ASSOCIATION_OF_REALTORS"] = 31224] = "PROVIDER_MARCO_ISLAND_AREA_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_MARTHAS_VINEYARD_MLS"] = 31225] = "PROVIDER_MARTHAS_VINEYARD_MLS";
    Provider[Provider["PROVIDER_MARTIN_COUNTY_REALTORS_OF_THE_TREASURE_COAST"] = 31226] = "PROVIDER_MARTIN_COUNTY_REALTORS_OF_THE_TREASURE_COAST";
    Provider[Provider["PROVIDER_MEMPHIS_AREA_ASSOCIATION_OF_REALTORS"] = 31227] = "PROVIDER_MEMPHIS_AREA_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_MERCER_TAZEWELL_CO_BOR"] = 31228] = "PROVIDER_MERCER_TAZEWELL_CO_BOR";
    Provider[Provider["PROVIDER_METROLIST_CA"] = 31229] = "PROVIDER_METROLIST_CA";
    Provider[Provider["PROVIDER_METRO_MLS"] = 31230] = "PROVIDER_METRO_MLS";
    Provider[Provider["PROVIDER_MEXICO"] = 31231] = "PROVIDER_MEXICO";
    Provider[Provider["PROVIDER_MIBOR_SERVICE_CORPORATION"] = 31232] = "PROVIDER_MIBOR_SERVICE_CORPORATION";
    Provider[Provider["PROVIDER_MICHIGAN_REGIONAL_INFORMATION_CENTER"] = 31233] = "PROVIDER_MICHIGAN_REGIONAL_INFORMATION_CENTER";
    Provider[Provider["PROVIDER_MID_AMERICA_REGIONAL_INFORMATION_SYSTEMS"] = 31234] = "PROVIDER_MID_AMERICA_REGIONAL_INFORMATION_SYSTEMS";
    Provider[Provider["PROVIDER_MIDDLE_GEORGIA_MLS"] = 31235] = "PROVIDER_MIDDLE_GEORGIA_MLS";
    Provider[Provider["PROVIDER_MIDDLE_TENNESSEE_REGIONAL_MLS"] = 31236] = "PROVIDER_MIDDLE_TENNESSEE_REGIONAL_MLS";
    Provider[Provider["PROVIDER_MIDHUDSON_MULTIPLE_LISTING_SERVICE"] = 31237] = "PROVIDER_MIDHUDSON_MULTIPLE_LISTING_SERVICE";
    Provider[Provider["PROVIDER_MIDWEST_REAL_ESTATE_DATA"] = 31238] = "PROVIDER_MIDWEST_REAL_ESTATE_DATA";
    Provider[Provider["PROVIDER_MILLEDGEVILLE_MLS"] = 31239] = "PROVIDER_MILLEDGEVILLE_MLS";
    Provider[Provider["PROVIDER_MLS_LISTINGS_INC"] = 31240] = "PROVIDER_MLS_LISTINGS_INC";
    Provider[Provider["PROVIDER_MLS_NOW"] = 31241] = "PROVIDER_MLS_NOW";
    Provider[Provider["PROVIDER_MLS_OF_CENTRAL_OREGON"] = 31242] = "PROVIDER_MLS_OF_CENTRAL_OREGON";
    Provider[Provider["PROVIDER_MLS_OF_GREATER_CINCINNATI_INC"] = 31243] = "PROVIDER_MLS_OF_GREATER_CINCINNATI_INC";
    Provider[Provider["PROVIDER_MLS_OF_YAKIMA_ASSOCIATION"] = 31244] = "PROVIDER_MLS_OF_YAKIMA_ASSOCIATION";
    Provider[Provider["PROVIDER_MLS_PROPERTY_INFORMATION_NETWORK"] = 31245] = "PROVIDER_MLS_PROPERTY_INFORMATION_NETWORK";
    Provider[Provider["PROVIDER_MLS_TECHNOLOGY"] = 31246] = "PROVIDER_MLS_TECHNOLOGY";
    Provider[Provider["PROVIDER_MLS_UNITED"] = 31247] = "PROVIDER_MLS_UNITED";
    Provider[Provider["PROVIDER_MONMOUTHOCEAN_MULTIPLE_LISTING_SERVICE"] = 31248] = "PROVIDER_MONMOUTHOCEAN_MULTIPLE_LISTING_SERVICE";
    Provider[Provider["PROVIDER_MONTANA_REGIONAL_MLS"] = 31249] = "PROVIDER_MONTANA_REGIONAL_MLS";
    Provider[Provider["PROVIDER_MONTGOMERY_AREA_ASSOCIATION_OF_REALTORS_MLS"] = 31250] = "PROVIDER_MONTGOMERY_AREA_ASSOCIATION_OF_REALTORS_MLS";
    Provider[Provider["PROVIDER_MOUNTAIN_LAKES_BOARD_OF_REALTORS"] = 31251] = "PROVIDER_MOUNTAIN_LAKES_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_MT_RUSHMORE_AREA_ASSOCIATION_OF_REALTORS"] = 31252] = "PROVIDER_MT_RUSHMORE_AREA_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_MULTIPLE_LISTING_SERVICE_MIREALSOURCE"] = 31253] = "PROVIDER_MULTIPLE_LISTING_SERVICE_MIREALSOURCE";
    Provider[Provider["PROVIDER_MULTIPLE_LISTING_SERVICE_OF_HILTON_HEAD_ISLAND_INC"] = 31254] = "PROVIDER_MULTIPLE_LISTING_SERVICE_OF_HILTON_HEAD_ISLAND_INC";
    Provider[Provider["PROVIDER_MULTIPLE_LISTING_SERVICE_OF_SOUTHERN_ARIZONA"] = 31255] = "PROVIDER_MULTIPLE_LISTING_SERVICE_OF_SOUTHERN_ARIZONA";
    Provider[Provider["PROVIDER_NAPLES_AREA_BOARD_OF_REALTORS"] = 31256] = "PROVIDER_NAPLES_AREA_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_NEUSE_RIVER_REGION_MLS_INC"] = 31257] = "PROVIDER_NEUSE_RIVER_REGION_MLS_INC";
    Provider[Provider["PROVIDER_NEW_CANAAN_BOARD_OF_REALTORS"] = 31258] = "PROVIDER_NEW_CANAAN_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_NEW_JERSEY_MLS"] = 31259] = "PROVIDER_NEW_JERSEY_MLS";
    Provider[Provider["PROVIDER_NEW_SMYRNA_BEACH_BOARD_OF_REALTORS"] = 31260] = "PROVIDER_NEW_SMYRNA_BEACH_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_NEW_YORK_STATE_ALLIANCE_OF_MLSS"] = 31261] = "PROVIDER_NEW_YORK_STATE_ALLIANCE_OF_MLSS";
    Provider[Provider["PROVIDER_NEW_ZEALAND"] = 31262] = "PROVIDER_NEW_ZEALAND";
    Provider[Provider["PROVIDER_NORTH_CENTRAL_WEST_VIRGINIA_REAL_ESTATE_INFORMATION_NETWORK"] = 31263] = "PROVIDER_NORTH_CENTRAL_WEST_VIRGINIA_REAL_ESTATE_INFORMATION_NETWORK";
    Provider[Provider["PROVIDER_NORTHEAST_ARKANSAS_BOARD_OF_REALTORS"] = 31264] = "PROVIDER_NORTHEAST_ARKANSAS_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_NORTHEAST_GEORGIA_BOARD_OF_REALTORS"] = 31265] = "PROVIDER_NORTHEAST_GEORGIA_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_NORTHEAST_IOWA_REGIONAL_BOARD_OF_REALTORS"] = 31266] = "PROVIDER_NORTHEAST_IOWA_REGIONAL_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_NORTHEAST_LOUISIANA_ASSOCIATION_OF_REALTORS"] = 31267] = "PROVIDER_NORTHEAST_LOUISIANA_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_NORTHEAST_OKLAHOMA_BOARD_OF_REALTORS"] = 31268] = "PROVIDER_NORTHEAST_OKLAHOMA_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_NORTHERN_ARIZONA_ASSOCIATION_OF_REALTORS"] = 31269] = "PROVIDER_NORTHERN_ARIZONA_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_NORTHERN_GREAT_LAKES_REALTORS_MLS"] = 31270] = "PROVIDER_NORTHERN_GREAT_LAKES_REALTORS_MLS";
    Provider[Provider["PROVIDER_NORTHERN_KENTUCKY_MULTIPLE_LISTING_SERVICE"] = 31271] = "PROVIDER_NORTHERN_KENTUCKY_MULTIPLE_LISTING_SERVICE";
    Provider[Provider["PROVIDER_NORTHERN_NEVADA_REGIONAL_MLS_INC"] = 31272] = "PROVIDER_NORTHERN_NEVADA_REGIONAL_MLS_INC";
    Provider[Provider["PROVIDER_NORTH_FLORIDA_MLS"] = 31273] = "PROVIDER_NORTH_FLORIDA_MLS";
    Provider[Provider["PROVIDER_NORTH_SANTA_BARBARA_COUNTY_REGIONAL_MLS"] = 31274] = "PROVIDER_NORTH_SANTA_BARBARA_COUNTY_REGIONAL_MLS";
    Provider[Provider["PROVIDER_NORTHSTARMLS"] = 31275] = "PROVIDER_NORTHSTARMLS";
    Provider[Provider["PROVIDER_NORTH_TEXAS_REAL_ESTATE_INFORMATION_SYSTEMS"] = 31276] = "PROVIDER_NORTH_TEXAS_REAL_ESTATE_INFORMATION_SYSTEMS";
    Provider[Provider["PROVIDER_NORTHWEST_ARKANSAS_BOARD_OF_REALTORS"] = 31277] = "PROVIDER_NORTHWEST_ARKANSAS_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_NORTHWESTERN_WISCONSIN_MULTIPLE_LISTING_SERVICE"] = 31278] = "PROVIDER_NORTHWESTERN_WISCONSIN_MULTIPLE_LISTING_SERVICE";
    Provider[Provider["PROVIDER_NORTHWEST_IOWA_MLS"] = 31279] = "PROVIDER_NORTHWEST_IOWA_MLS";
    Provider[Provider["PROVIDER_NORTHWEST_MISSISSIPPI_ASSOCIATION_OF_REALTORS"] = 31280] = "PROVIDER_NORTHWEST_MISSISSIPPI_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_NORTHWEST_MLS"] = 31281] = "PROVIDER_NORTHWEST_MLS";
    Provider[Provider["PROVIDER_NORTHWEST_OHIO_REAL_ESTATE_INFORMATION_SYSTEMS"] = 31282] = "PROVIDER_NORTHWEST_OHIO_REAL_ESTATE_INFORMATION_SYSTEMS";
    Provider[Provider["PROVIDER_NORTHWOODS_ASSOCIATION_OF_REALTORS"] = 31283] = "PROVIDER_NORTHWOODS_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_OLD_KENTUCKY_HOME_BOARD_OF_REALTORS"] = 31284] = "PROVIDER_OLD_KENTUCKY_HOME_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_ONEKEY_MLS"] = 31285] = "PROVIDER_ONEKEY_MLS";
    Provider[Provider["PROVIDER_OUTER_BANKS_ASSOCIATION_OF_REALTORS"] = 31286] = "PROVIDER_OUTER_BANKS_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_OZARK_GATEWAY_ASSOCIATION_OF_REALTORS"] = 31287] = "PROVIDER_OZARK_GATEWAY_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_PACIFIC_REGIONAL_MLS"] = 31288] = "PROVIDER_PACIFIC_REGIONAL_MLS";
    Provider[Provider["PROVIDER_PAGE_LAKE_POWELL_MLS"] = 31289] = "PROVIDER_PAGE_LAKE_POWELL_MLS";
    Provider[Provider["PROVIDER_PALESTINE_ASSOCIATION_OF_REALTORS"] = 31290] = "PROVIDER_PALESTINE_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_PALM_BEACH_BOARD_OF_REALTORS"] = 31291] = "PROVIDER_PALM_BEACH_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_PALMETTO_MULTIPLE_LISTING_SERVICE"] = 31292] = "PROVIDER_PALMETTO_MULTIPLE_LISTING_SERVICE";
    Provider[Provider["PROVIDER_PANAMA"] = 31293] = "PROVIDER_PANAMA";
    Provider[Provider["PROVIDER_PARK_CITY_BOARD_OF_REALTORS"] = 31294] = "PROVIDER_PARK_CITY_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_PEARL_RIVER_COUNTY_BOARD_OF_REALTORS"] = 31295] = "PROVIDER_PEARL_RIVER_COUNTY_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_PENSACOLA_ASSOCIATION_OF_REALTORS"] = 31296] = "PROVIDER_PENSACOLA_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_PERMIAN_BASIN_BOARD_OF_REALTORS"] = 31297] = "PROVIDER_PERMIAN_BASIN_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_PIKES_PEAK_ASSOCIATION_OF_REALTORS"] = 31298] = "PROVIDER_PIKES_PEAK_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_PIKEWAYNE_ASSOCIATION_OF_REALTORS_MLS"] = 31299] = "PROVIDER_PIKEWAYNE_ASSOCIATION_OF_REALTORS_MLS";
    Provider[Provider["PROVIDER_POCONO_MOUNTAINS_ASSOCIATION_OF_REALTORS"] = 31300] = "PROVIDER_POCONO_MOUNTAINS_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_PORT_NECHES_PORT_ARTHUR_NEDERLAND_BOARD_OF_REALTORS_INC_MLS"] = 31301] = "PROVIDER_PORT_NECHES_PORT_ARTHUR_NEDERLAND_BOARD_OF_REALTORS_INC_MLS";
    Provider[Provider["PROVIDER_PORTUGAL"] = 31302] = "PROVIDER_PORTUGAL";
    Provider[Provider["PROVIDER_PRESCOTT_AREA_ASSOCIATION_OF_REALTORS"] = 31303] = "PROVIDER_PRESCOTT_AREA_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_PRIMEMLS"] = 31304] = "PROVIDER_PRIMEMLS";
    Provider[Provider["PROVIDER_PUEBLO_ASSOCIATION_OF_REALTORS"] = 31305] = "PROVIDER_PUEBLO_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_PUERTO_RICO"] = 31306] = "PROVIDER_PUERTO_RICO";
    Provider[Provider["PROVIDER_QAMLS2"] = 31307] = "PROVIDER_QAMLS2";
    Provider[Provider["PROVIDER_QAMLS3"] = 31308] = "PROVIDER_QAMLS3";
    Provider[Provider["PROVIDER_QAMLS4"] = 31309] = "PROVIDER_QAMLS4";
    Provider[Provider["PROVIDER_RANDOLPH_COUNTY_BOARD_OF_REALTORS"] = 31310] = "PROVIDER_RANDOLPH_COUNTY_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_RANGE_ASSOCIATION_OF_REALTORS"] = 31311] = "PROVIDER_RANGE_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_REALCOMP_LIMITED_II"] = 31312] = "PROVIDER_REALCOMP_LIMITED_II";
    Provider[Provider["PROVIDER_REAL_ESTATE_INFORMATION_NETWORK_INC"] = 31313] = "PROVIDER_REAL_ESTATE_INFORMATION_NETWORK_INC";
    Provider[Provider["PROVIDER_REALMLS"] = 31314] = "PROVIDER_REALMLS";
    Provider[Provider["PROVIDER_REALTOR_ASSOCIATION_OF_ACADIANA"] = 31315] = "PROVIDER_REALTOR_ASSOCIATION_OF_ACADIANA";
    Provider[Provider["PROVIDER_REALTOR_ASSOCIATION_OF_FRANKLIN_AND_GULF_COUNTIES"] = 31316] = "PROVIDER_REALTOR_ASSOCIATION_OF_FRANKLIN_AND_GULF_COUNTIES";
    Provider[Provider["PROVIDER_REALTOR_ASSOCIATION_OF_NORTHEAST_WISCONSIN"] = 31317] = "PROVIDER_REALTOR_ASSOCIATION_OF_NORTHEAST_WISCONSIN";
    Provider[Provider["PROVIDER_REALTOR_ASSOCIATION_OF_SOUTHERN_KENTUCKY_INC"] = 31318] = "PROVIDER_REALTOR_ASSOCIATION_OF_SOUTHERN_KENTUCKY_INC";
    Provider[Provider["PROVIDER_REALTOR_ASSOCIATION_OF_SOUTHERN_MINNESOTA"] = 31319] = "PROVIDER_REALTOR_ASSOCIATION_OF_SOUTHERN_MINNESOTA";
    Provider[Provider["PROVIDER_REALTOR_ASSOCIATION_OF_THE_SIOUX_EMPIRE_MLS"] = 31320] = "PROVIDER_REALTOR_ASSOCIATION_OF_THE_SIOUX_EMPIRE_MLS";
    Provider[Provider["PROVIDER_REALTORS_ASSOCIATION_OF_CITRUS_COUNTY"] = 31321] = "PROVIDER_REALTORS_ASSOCIATION_OF_CITRUS_COUNTY";
    Provider[Provider["PROVIDER_REALTORS_ASSOCIATION_OF_INDIAN_RIVER_COUNTY"] = 31322] = "PROVIDER_REALTORS_ASSOCIATION_OF_INDIAN_RIVER_COUNTY";
    Provider[Provider["PROVIDER_REALTORS_ASSOCIATION_OF_MAUI_INC"] = 31323] = "PROVIDER_REALTORS_ASSOCIATION_OF_MAUI_INC";
    Provider[Provider["PROVIDER_RECOLORADO"] = 31324] = "PROVIDER_RECOLORADO";
    Provider[Provider["PROVIDER_REGIONAL_MULTIPLE_LISTING_SERVICES"] = 31325] = "PROVIDER_REGIONAL_MULTIPLE_LISTING_SERVICES";
    Provider[Provider["PROVIDER_RIDGECREST_AREA_ASSOCIATION_OF_REALTORS"] = 31326] = "PROVIDER_RIDGECREST_AREA_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_RIVER_COUNTIES_ASSOCIATION_OF_REALTORS"] = 31327] = "PROVIDER_RIVER_COUNTIES_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_RMLS_ALLIANCE_LLC"] = 31328] = "PROVIDER_RMLS_ALLIANCE_LLC";
    Provider[Provider["PROVIDER_ROANOKE_VALLEY_ASSOCIATION_OF_REALTORS"] = 31329] = "PROVIDER_ROANOKE_VALLEY_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_ROCKFORD_AREA_MLS"] = 31330] = "PROVIDER_ROCKFORD_AREA_MLS";
    Provider[Provider["PROVIDER_ROCKY_MOUNT_AREA_ASSOCIATION_OF_REALTORS"] = 31331] = "PROVIDER_ROCKY_MOUNT_AREA_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_ROYAL_PALM_COAST_REALTOR_ASSOCIATION"] = 31332] = "PROVIDER_ROYAL_PALM_COAST_REALTOR_ASSOCIATION";
    Provider[Provider["PROVIDER_RUIDOSOLINCOLN_COUNTY_ASSOCIATION_OF_REALTORS"] = 31333] = "PROVIDER_RUIDOSOLINCOLN_COUNTY_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_RUSSELLVILLE_BOARD_OF_REALTORS"] = 31334] = "PROVIDER_RUSSELLVILLE_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_SAN_ANGELO_ASSOCIATION_OF_REALTORS"] = 31335] = "PROVIDER_SAN_ANGELO_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_SAN_ANTONIO_BOARD_OF_REALTORS"] = 31336] = "PROVIDER_SAN_ANTONIO_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_SAN_DIEGO_MLS"] = 31337] = "PROVIDER_SAN_DIEGO_MLS";
    Provider[Provider["PROVIDER_SAN_FRANCISCO_ASSOCIATION_OF_REALTORS"] = 31338] = "PROVIDER_SAN_FRANCISCO_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_SAN_JUAN_ASSOCIATION_OF_REALTORS"] = 31339] = "PROVIDER_SAN_JUAN_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_SANTA_BARBARA_MULTIPLE_LISTING_SERVICE"] = 31340] = "PROVIDER_SANTA_BARBARA_MULTIPLE_LISTING_SERVICE";
    Provider[Provider["PROVIDER_SANTA_FE_ASSOCIATION_OF_REALTORS_INC"] = 31341] = "PROVIDER_SANTA_FE_ASSOCIATION_OF_REALTORS_INC";
    Provider[Provider["PROVIDER_SAVANNAH_MULTILIST_CORPORATION"] = 31342] = "PROVIDER_SAVANNAH_MULTILIST_CORPORATION";
    Provider[Provider["PROVIDER_SCIOTO_VALLEY_ASSOCIATION_OF_REALTORS"] = 31343] = "PROVIDER_SCIOTO_VALLEY_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_SEDONA_VERDE_VALLEY_ASSOCIATION_OF_REALTORS"] = 31344] = "PROVIDER_SEDONA_VERDE_VALLEY_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_SHASTA_MLS"] = 31345] = "PROVIDER_SHASTA_MLS";
    Provider[Provider["PROVIDER_SMART_MLS"] = 31346] = "PROVIDER_SMART_MLS";
    Provider[Provider["PROVIDER_SNAKE_RIVER_REGIONAL_MLS"] = 31347] = "PROVIDER_SNAKE_RIVER_REGIONAL_MLS";
    Provider[Provider["PROVIDER_SOUTH_AFRICA"] = 31348] = "PROVIDER_SOUTH_AFRICA";
    Provider[Provider["PROVIDER_SOUTH_BROWARD_BOARD_OF_REALTORS"] = 31349] = "PROVIDER_SOUTH_BROWARD_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_SOUTH_CENTRAL_ASSOCIATION_OF_REALTORS_MLS"] = 31350] = "PROVIDER_SOUTH_CENTRAL_ASSOCIATION_OF_REALTORS_MLS";
    Provider[Provider["PROVIDER_SOUTH_CENTRAL_KANSAS_MLS"] = 31351] = "PROVIDER_SOUTH_CENTRAL_KANSAS_MLS";
    Provider[Provider["PROVIDER_SOUTH_CENTRAL_WISCONSIN_MLS_CORPORATION"] = 31352] = "PROVIDER_SOUTH_CENTRAL_WISCONSIN_MLS_CORPORATION";
    Provider[Provider["PROVIDER_SOUTHEAST_ALASKA_MLS"] = 31353] = "PROVIDER_SOUTHEAST_ALASKA_MLS";
    Provider[Provider["PROVIDER_SOUTHEAST_KANSAS_MULTIPLE_LISTING_SYSTEM"] = 31354] = "PROVIDER_SOUTHEAST_KANSAS_MULTIPLE_LISTING_SYSTEM";
    Provider[Provider["PROVIDER_SOUTHERN_INDIANA_REALTOR_ASSOCIATION"] = 31355] = "PROVIDER_SOUTHERN_INDIANA_REALTOR_ASSOCIATION";
    Provider[Provider["PROVIDER_SOUTHERN_MISSOURI_REGIONAL_MLS_LLC"] = 31356] = "PROVIDER_SOUTHERN_MISSOURI_REGIONAL_MLS_LLC";
    Provider[Provider["PROVIDER_SOUTHERN_NEW_MEXICO_MLS"] = 31357] = "PROVIDER_SOUTHERN_NEW_MEXICO_MLS";
    Provider[Provider["PROVIDER_SOUTH_GEORGIA_MLS"] = 31358] = "PROVIDER_SOUTH_GEORGIA_MLS";
    Provider[Provider["PROVIDER_SOUTH_JERSEY_SHORE_REGIONAL_MLS"] = 31359] = "PROVIDER_SOUTH_JERSEY_SHORE_REGIONAL_MLS";
    Provider[Provider["PROVIDER_SOUTH_PADRE_ISLAND_BOARD_OF_REALTORS"] = 31360] = "PROVIDER_SOUTH_PADRE_ISLAND_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_SOUTHWEST_MLS"] = 31361] = "PROVIDER_SOUTHWEST_MLS";
    Provider[Provider["PROVIDER_SOUTHWEST_VIRGINIA_ASSOCIATION_OF_REALTORS"] = 31362] = "PROVIDER_SOUTHWEST_VIRGINIA_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_SPACE_COAST_ASSOCIATION_OF_REALTORS"] = 31363] = "PROVIDER_SPACE_COAST_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_SPACE_COAST_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY"] = 31364] = "PROVIDER_SPACE_COAST_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY";
    Provider[Provider["PROVIDER_SPAIN"] = 31365] = "PROVIDER_SPAIN";
    Provider[Provider["PROVIDER_SPARTANBURG_ASSOCIATION_OF_REALTORS_INC"] = 31366] = "PROVIDER_SPARTANBURG_ASSOCIATION_OF_REALTORS_INC";
    Provider[Provider["PROVIDER_SPOKANE_ASSOCIATION_OF_REALTORS"] = 31367] = "PROVIDER_SPOKANE_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_STATEN_ISLAND_BOARD_OF_REALTORS"] = 31368] = "PROVIDER_STATEN_ISLAND_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_STATE_WIDE_MLS_OF_RHODE_ISLAND_INC"] = 31369] = "PROVIDER_STATE_WIDE_MLS_OF_RHODE_ISLAND_INC";
    Provider[Provider["PROVIDER_ST_AUGUSTINE_ST_JOHNS_COUNTY_BOARD_OF_REALTORS"] = 31370] = "PROVIDER_ST_AUGUSTINE_ST_JOHNS_COUNTY_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_STILLWATER_BOARD_OF_REALTORS"] = 31371] = "PROVIDER_STILLWATER_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_STRATEGIC_MLS_ALLIANCE"] = 31372] = "PROVIDER_STRATEGIC_MLS_ALLIANCE";
    Provider[Provider["PROVIDER_SUMMIT_ASSOCIATION_OF_REALTORS"] = 31373] = "PROVIDER_SUMMIT_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_SUNFLOWER_ASSOCIATION_OF_REALTORS"] = 31374] = "PROVIDER_SUNFLOWER_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_TAHOE_SIERRA_BOARD_OF_REALTORS"] = 31375] = "PROVIDER_TAHOE_SIERRA_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_TAOS_COUNTY_ASSOCIATION_OF_REALTORS"] = 31376] = "PROVIDER_TAOS_COUNTY_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_TENNESSEE_VIRGINIA_REGIONAL_MULTIPLE_LISTING_SERVICE"] = 31377] = "PROVIDER_TENNESSEE_VIRGINIA_REGIONAL_MULTIPLE_LISTING_SERVICE";
    Provider[Provider["PROVIDER_TETON_BOARD_OF_REALTORS"] = 31378] = "PROVIDER_TETON_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_TEXARKANA_BOARD_OF_REALTORS"] = 31379] = "PROVIDER_TEXARKANA_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_TILLAMOOK_COUNTY_BOARD_OF_REALTORS_MLS"] = 31380] = "PROVIDER_TILLAMOOK_COUNTY_BOARD_OF_REALTORS_MLS";
    Provider[Provider["PROVIDER_TOPSAIL_ISLAND_ASSOCIATION_OF_REALTORS"] = 31381] = "PROVIDER_TOPSAIL_ISLAND_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_TRIAD_MULTIPLE_LISTING_SERVICE"] = 31382] = "PROVIDER_TRIAD_MULTIPLE_LISTING_SERVICE";
    Provider[Provider["PROVIDER_TRIANGLE_MLS"] = 31383] = "PROVIDER_TRIANGLE_MLS";
    Provider[Provider["PROVIDER_TRINITY_COUNTY_MLS"] = 31384] = "PROVIDER_TRINITY_COUNTY_MLS";
    Provider[Provider["PROVIDER_TULARE_COUNTY_MLS"] = 31385] = "PROVIDER_TULARE_COUNTY_MLS";
    Provider[Provider["PROVIDER_TUOLUMNE_COUNTY_ASSOCIATION_OF_REALTORS"] = 31386] = "PROVIDER_TUOLUMNE_COUNTY_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_ULSTER_COUNTY_BOARD_OF_REALTORS_MLS"] = 31387] = "PROVIDER_ULSTER_COUNTY_BOARD_OF_REALTORS_MLS";
    Provider[Provider["PROVIDER_UPPER_CUMBERLAND_ASSOCIATION_OF_REALTORS"] = 31388] = "PROVIDER_UPPER_CUMBERLAND_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_UPPER_PENINSULA_ASSOCIATION_OF_REALTORS"] = 31389] = "PROVIDER_UPPER_PENINSULA_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_VAIL_BOARD_OF_REALTORS_MLS"] = 31390] = "PROVIDER_VAIL_BOARD_OF_REALTORS_MLS";
    Provider[Provider["PROVIDER_VALLEY_MLS"] = 31391] = "PROVIDER_VALLEY_MLS";
    Provider[Provider["PROVIDER_WACO_ASSOCIATION_OF_REALTORS"] = 31392] = "PROVIDER_WACO_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_WASATCH_FRONT_REGIONAL_MLS"] = 31393] = "PROVIDER_WASATCH_FRONT_REGIONAL_MLS";
    Provider[Provider["PROVIDER_WASHINGTON_BEAUFORT_COUNTY_BOARD_OF_REALTORS"] = 31394] = "PROVIDER_WASHINGTON_BEAUFORT_COUNTY_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_WASHINGTON_COUNTY_BOARD_OF_REALTORS"] = 31395] = "PROVIDER_WASHINGTON_COUNTY_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_WEST_ALABAMA_MULTIPLE_LISTING_SERVICE"] = 31396] = "PROVIDER_WEST_ALABAMA_MULTIPLE_LISTING_SERVICE";
    Provider[Provider["PROVIDER_WEST_CENTRAL_ASSOCIATION_OF_REALTORS"] = 31397] = "PROVIDER_WEST_CENTRAL_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_WESTCLIFFE_LISTING_SERVICE"] = 31398] = "PROVIDER_WESTCLIFFE_LISTING_SERVICE";
    Provider[Provider["PROVIDER_WESTERN_ARIZONA_REALTOR_DATA_EXCHANGE"] = 31399] = "PROVIDER_WESTERN_ARIZONA_REALTOR_DATA_EXCHANGE";
    Provider[Provider["PROVIDER_WESTERN_REGIONAL_INFORMATION_SYSTEMS_AND_TECHNOLOGY_INC"] = 31400] = "PROVIDER_WESTERN_REGIONAL_INFORMATION_SYSTEMS_AND_TECHNOLOGY_INC";
    Provider[Provider["PROVIDER_WESTERN_UPSTATE_ASSOCIATION_OF_REALTORS"] = 31401] = "PROVIDER_WESTERN_UPSTATE_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_WEST_PENN_MULTI_LIST"] = 31402] = "PROVIDER_WEST_PENN_MULTI_LIST";
    Provider[Provider["PROVIDER_WHEELING_BOARD_OF_REALTORS"] = 31403] = "PROVIDER_WHEELING_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_WHITE_MOUNTAIN_ASSOCIATION_OF_REALTORS"] = 31404] = "PROVIDER_WHITE_MOUNTAIN_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_WILLAMETTE_VALLEY_MULTIPLE_LISTING_SERVICE"] = 31405] = "PROVIDER_WILLAMETTE_VALLEY_MULTIPLE_LISTING_SERVICE";
    Provider[Provider["PROVIDER_WILSON_BOARD_OF_REALTORS"] = 31406] = "PROVIDER_WILSON_BOARD_OF_REALTORS";
    Provider[Provider["PROVIDER_WINNIPEG_REGIONAL_REAL_ESTATE_BOARD"] = 31407] = "PROVIDER_WINNIPEG_REGIONAL_REAL_ESTATE_BOARD";
    Provider[Provider["PROVIDER_WYOMING_MLS"] = 31408] = "PROVIDER_WYOMING_MLS";
    Provider[Provider["PROVIDER_YUMA_ASSOCIATION_OF_REALTORS"] = 31409] = "PROVIDER_YUMA_ASSOCIATION_OF_REALTORS";
    Provider[Provider["PROVIDER_NORTH_CAROLINA_REGIONAL_MULTIPLE_LISTING_SERVICE"] = 31412] = "PROVIDER_NORTH_CAROLINA_REGIONAL_MULTIPLE_LISTING_SERVICE";
    Provider[Provider["PROVIDER_AGENT_UPLOAD"] = 90000] = "PROVIDER_AGENT_UPLOAD";
    Provider[Provider["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Provider || (exports.Provider = Provider = {}));
function providerFromJSON(object) {
    switch (object) {
        case 0:
        case "PROVIDER_UNSPECIFIED":
            return Provider.PROVIDER_UNSPECIFIED;
        case 30005:
        case "PROVIDER_VREB_IDX":
            return Provider.PROVIDER_VREB_IDX;
        case 30010:
        case "PROVIDER_LDON_IDX":
            return Provider.PROVIDER_LDON_IDX;
        case 30003:
        case "PROVIDER_NSAR_IDX":
            return Provider.PROVIDER_NSAR_IDX;
        case 30004:
        case "PROVIDER_NSAR_VOW":
            return Provider.PROVIDER_NSAR_VOW;
        case 30006:
        case "PROVIDER_ALB_IDX":
            return Provider.PROVIDER_ALB_IDX;
        case 30012:
        case "PROVIDER_CREB_IDX":
            return Provider.PROVIDER_CREB_IDX;
        case 30008:
        case "PROVIDER_BRC_IDX":
            return Provider.PROVIDER_BRC_IDX;
        case 30000:
        case "PROVIDER_TREB_VOW":
            return Provider.PROVIDER_TREB_VOW;
        case 30001:
        case "PROVIDER_TREB_IDX":
            return Provider.PROVIDER_TREB_IDX;
        case 30007:
        case "PROVIDER_RAHB_IDX":
            return Provider.PROVIDER_RAHB_IDX;
        case 30009:
        case "PROVIDER_ITSO_IDX":
            return Provider.PROVIDER_ITSO_IDX;
        case 30011:
        case "PROVIDER_OREB_VOW":
            return Provider.PROVIDER_OREB_VOW;
        case 30002:
        case "PROVIDER_CREA_DDF":
            return Provider.PROVIDER_CREA_DDF;
        case 31013:
        case "PROVIDER_ITSO_VOW":
            return Provider.PROVIDER_ITSO_VOW;
        case 31014:
        case "PROVIDER_PILLAR9_IDX":
            return Provider.PROVIDER_PILLAR9_IDX;
        case 31015:
        case "PROVIDER_PILLAR9_VOW":
            return Provider.PROVIDER_PILLAR9_VOW;
        case 31016:
        case "PROVIDER_REBGV_IDX":
            return Provider.PROVIDER_REBGV_IDX;
        case 31017:
        case "PROVIDER_REBGV_VOW":
            return Provider.PROVIDER_REBGV_VOW;
        case 31018:
        case "PROVIDER_STELLAR_MLS_IDX":
            return Provider.PROVIDER_STELLAR_MLS_IDX;
        case 31019:
        case "PROVIDER_MIAMI_SEF_IDX_PLUS":
            return Provider.PROVIDER_MIAMI_SEF_IDX_PLUS;
        case 31020:
        case "PROVIDER_BRIGHT_MLS":
            return Provider.PROVIDER_BRIGHT_MLS;
        case 31021:
        case "PROVIDER_ABERDEEN_BOARD_OF_REALTORS":
            return Provider.PROVIDER_ABERDEEN_BOARD_OF_REALTORS;
        case 31022:
        case "PROVIDER_ADIRONDACK_CHAMPLAIN_VALLEY_MLS":
            return Provider.PROVIDER_ADIRONDACK_CHAMPLAIN_VALLEY_MLS;
        case 31023:
        case "PROVIDER_AIKEN_MLS":
            return Provider.PROVIDER_AIKEN_MLS;
        case 31024:
        case "PROVIDER_ALAMANCE_MULTIPLE_LISTING_SERVICE":
            return Provider.PROVIDER_ALAMANCE_MULTIPLE_LISTING_SERVICE;
        case 31025:
        case "PROVIDER_ALASKA_MULTIPLE_LISTING_SERVICE":
            return Provider.PROVIDER_ALASKA_MULTIPLE_LISTING_SERVICE;
        case 31026:
        case "PROVIDER_ALLEGHENY_HIGHLAND_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_ALLEGHENY_HIGHLAND_ASSOCIATION_OF_REALTORS;
        case 31027:
        case "PROVIDER_AMELIA_ISLANDUNDEFINED_NASSAU_COUNTY_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_AMELIA_ISLANDUNDEFINED_NASSAU_COUNTY_ASSOCIATION_OF_REALTORS;
        case 31028:
        case "PROVIDER_ARIZONA_REGIONAL_MULTIPLE_LISTING_SERVICE":
            return Provider.PROVIDER_ARIZONA_REGIONAL_MULTIPLE_LISTING_SERVICE;
        case 31029:
        case "PROVIDER_ARIZONA_REGIONAL_MULTIPLE_LISTING_SERVICE_EXP_PORTAL_ONLY":
            return Provider.PROVIDER_ARIZONA_REGIONAL_MULTIPLE_LISTING_SERVICE_EXP_PORTAL_ONLY;
        case 31030:
        case "PROVIDER_ASHLAND_AREA_BOARD_OF_REALTORS":
            return Provider.PROVIDER_ASHLAND_AREA_BOARD_OF_REALTORS;
        case 31031:
        case "PROVIDER_ASHLAND_BOARD_OF_REALTORS":
            return Provider.PROVIDER_ASHLAND_BOARD_OF_REALTORS;
        case 31032:
        case "PROVIDER_ASPEN_GLENWOOD_MLS":
            return Provider.PROVIDER_ASPEN_GLENWOOD_MLS;
        case 31033:
        case "PROVIDER_ASSOCIATED_MULTILIST_SERVICES_OF_OKLAHOMA":
            return Provider.PROVIDER_ASSOCIATED_MULTILIST_SERVICES_OF_OKLAHOMA;
        case 31034:
        case "PROVIDER_ATHENS_AREA_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_ATHENS_AREA_ASSOCIATION_OF_REALTORS;
        case 31035:
        case "PROVIDER_ATHENS_COUNTY_BOARD_OF_REALTORS":
            return Provider.PROVIDER_ATHENS_COUNTY_BOARD_OF_REALTORS;
        case 31036:
        case "PROVIDER_AUSTIN_CENTRAL_TEXAS_REALTY_INFORMATION_SERVICE":
            return Provider.PROVIDER_AUSTIN_CENTRAL_TEXAS_REALTY_INFORMATION_SERVICE;
        case 31037:
        case "PROVIDER_BADLANDS_BOARD_OF_REALTORS_INC_MLS":
            return Provider.PROVIDER_BADLANDS_BOARD_OF_REALTORS_INC_MLS;
        case 31038:
        case "PROVIDER_BAKERSFIELD_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_BAKERSFIELD_ASSOCIATION_OF_REALTORS;
        case 31039:
        case "PROVIDER_BALDWIN_REALTORS":
            return Provider.PROVIDER_BALDWIN_REALTORS;
        case 31040:
        case "PROVIDER_BAY_AREA_REAL_ESTATE_INFORMATION_SERVICES_INC":
            return Provider.PROVIDER_BAY_AREA_REAL_ESTATE_INFORMATION_SERVICES_INC;
        case 31041:
        case "PROVIDER_BEACHES_MLS":
            return Provider.PROVIDER_BEACHES_MLS;
        case 31042:
        case "PROVIDER_BEACHES_MLS_EXP_PORTAL_ONLY":
            return Provider.PROVIDER_BEACHES_MLS_EXP_PORTAL_ONLY;
        case 31043:
        case "PROVIDER_BEAUMONT_BOARD_OF_REALTORS_INC_MLS":
            return Provider.PROVIDER_BEAUMONT_BOARD_OF_REALTORS_INC_MLS;
        case 31044:
        case "PROVIDER_BERKSHIRE_COUNTY_BOARD_OF_REALTORS":
            return Provider.PROVIDER_BERKSHIRE_COUNTY_BOARD_OF_REALTORS;
        case 31045:
        case "PROVIDER_BIG_SKY_COUNTRY_MLS":
            return Provider.PROVIDER_BIG_SKY_COUNTRY_MLS;
        case 31046:
        case "PROVIDER_BILLINGS_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_BILLINGS_ASSOCIATION_OF_REALTORS;
        case 31047:
        case "PROVIDER_BILLINGS_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY":
            return Provider.PROVIDER_BILLINGS_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY;
        case 31048:
        case "PROVIDER_BISMARCK_MANDAN_BOARD_OF_REALTORS":
            return Provider.PROVIDER_BISMARCK_MANDAN_BOARD_OF_REALTORS;
        case 31049:
        case "PROVIDER_BLACK_HILLS_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_BLACK_HILLS_ASSOCIATION_OF_REALTORS;
        case 31050:
        case "PROVIDER_BLUEGRASS_REALTORS":
            return Provider.PROVIDER_BLUEGRASS_REALTORS;
        case 31051:
        case "PROVIDER_BONITA_SPRINGS_ESTERO_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_BONITA_SPRINGS_ESTERO_ASSOCIATION_OF_REALTORS;
        case 31052:
        case "PROVIDER_BRASIL":
            return Provider.PROVIDER_BRASIL;
        case 31053:
        case "PROVIDER_BRAZORIA_COUNTY_BOARD_OF_REALTORS":
            return Provider.PROVIDER_BRAZORIA_COUNTY_BOARD_OF_REALTORS;
        case 31054:
        case "PROVIDER_BROOKLYN_NEW_YORK_MLS":
            return Provider.PROVIDER_BROOKLYN_NEW_YORK_MLS;
        case 31055:
        case "PROVIDER_BRUNSWICK_COUNTY_MLS":
            return Provider.PROVIDER_BRUNSWICK_COUNTY_MLS;
        case 31056:
        case "PROVIDER_BRYANCOLLEGE_STATION_REGIONAL_MLS":
            return Provider.PROVIDER_BRYANCOLLEGE_STATION_REGIONAL_MLS;
        case 31057:
        case "PROVIDER_CALAVERAS_COUNTY_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_CALAVERAS_COUNTY_ASSOCIATION_OF_REALTORS;
        case 31058:
        case "PROVIDER_CALIFORNIA_REGIONAL_MULTIPLE_LISTING_SERVICE":
            return Provider.PROVIDER_CALIFORNIA_REGIONAL_MULTIPLE_LISTING_SERVICE;
        case 31059:
        case "PROVIDER_CAMBRIA_SOMERSET_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_CAMBRIA_SOMERSET_ASSOCIATION_OF_REALTORS;
        case 31060:
        case "PROVIDER_CANOPY_MLS":
            return Provider.PROVIDER_CANOPY_MLS;
        case 31061:
        case "PROVIDER_CAPE_CODUNDEFINED_ISLANDS_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_CAPE_CODUNDEFINED_ISLANDS_ASSOCIATION_OF_REALTORS;
        case 31062:
        case "PROVIDER_CAPE_FEAR_REALTORS":
            return Provider.PROVIDER_CAPE_FEAR_REALTORS;
        case 31063:
        case "PROVIDER_CAPE_MAY_COUNTY_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_CAPE_MAY_COUNTY_ASSOCIATION_OF_REALTORS;
        case 31064:
        case "PROVIDER_CAPITAL_AREA_TECHNOLOGY_REALTOR_SERVICES":
            return Provider.PROVIDER_CAPITAL_AREA_TECHNOLOGY_REALTOR_SERVICES;
        case 31065:
        case "PROVIDER_CARPET_CAPITAL_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_CARPET_CAPITAL_ASSOCIATION_OF_REALTORS;
        case 31066:
        case "PROVIDER_CARPET_CAPITAL_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY":
            return Provider.PROVIDER_CARPET_CAPITAL_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY;
        case 31067:
        case "PROVIDER_CARTERET_COUNTY_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_CARTERET_COUNTY_ASSOCIATION_OF_REALTORS;
        case 31068:
        case "PROVIDER_CEDAR_RAPIDS_AREA_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_CEDAR_RAPIDS_AREA_ASSOCIATION_OF_REALTORS;
        case 31069:
        case "PROVIDER_CENTRAL_GEORGIA_MLS":
            return Provider.PROVIDER_CENTRAL_GEORGIA_MLS;
        case 31070:
        case "PROVIDER_CENTRAL_GEORGIA_MLS_EXP_PORTAL_ONLY":
            return Provider.PROVIDER_CENTRAL_GEORGIA_MLS_EXP_PORTAL_ONLY;
        case 31071:
        case "PROVIDER_CENTRAL_HILL_COUNTRY_BOARD_OF_REALTORS":
            return Provider.PROVIDER_CENTRAL_HILL_COUNTRY_BOARD_OF_REALTORS;
        case 31072:
        case "PROVIDER_CENTRAL_ILLINOIS_BOARD_OF_REALTORS":
            return Provider.PROVIDER_CENTRAL_ILLINOIS_BOARD_OF_REALTORS;
        case 31073:
        case "PROVIDER_CENTRAL_JERSEY_MULTIPLE_LISTING_SYSTEM_INC":
            return Provider.PROVIDER_CENTRAL_JERSEY_MULTIPLE_LISTING_SYSTEM_INC;
        case 31074:
        case "PROVIDER_CENTRAL_MISSISSIPPI_MLS":
            return Provider.PROVIDER_CENTRAL_MISSISSIPPI_MLS;
        case 31075:
        case "PROVIDER_CENTRAL_PANHANDLE_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_CENTRAL_PANHANDLE_ASSOCIATION_OF_REALTORS;
        case 31076:
        case "PROVIDER_CENTRAL_SUSQUEHANNA_VALLEY_BOARD_OF_REALTORS":
            return Provider.PROVIDER_CENTRAL_SUSQUEHANNA_VALLEY_BOARD_OF_REALTORS;
        case 31077:
        case "PROVIDER_CENTRAL_TEXAS_MULTIPLE_LISTING_SERVICE":
            return Provider.PROVIDER_CENTRAL_TEXAS_MULTIPLE_LISTING_SERVICE;
        case 31078:
        case "PROVIDER_CENTRAL_VIRGINIA_REGIONAL_MULTIPLE_LISTING_SERVICE":
            return Provider.PROVIDER_CENTRAL_VIRGINIA_REGIONAL_MULTIPLE_LISTING_SERVICE;
        case 31079:
        case "PROVIDER_CENTRAL_WEST_TENNESSEE_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_CENTRAL_WEST_TENNESSEE_ASSOCIATION_OF_REALTORS;
        case 31080:
        case "PROVIDER_CENTRAL_WISCONSIN_MLS":
            return Provider.PROVIDER_CENTRAL_WISCONSIN_MLS;
        case 31081:
        case "PROVIDER_CHARLOTTESVILLE_AREA_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_CHARLOTTESVILLE_AREA_ASSOCIATION_OF_REALTORS;
        case 31082:
        case "PROVIDER_CHS_REGIONAL_MLS":
            return Provider.PROVIDER_CHS_REGIONAL_MLS;
        case 31083:
        case "PROVIDER_CLATSOP_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_CLATSOP_ASSOCIATION_OF_REALTORS;
        case 31084:
        case "PROVIDER_CLEARFIELDJEFFERSON_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_CLEARFIELDJEFFERSON_ASSOCIATION_OF_REALTORS;
        case 31085:
        case "PROVIDER_COASTAL_CAROLINA_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_COASTAL_CAROLINA_ASSOCIATION_OF_REALTORS;
        case 31086:
        case "PROVIDER_COEUR_DALENE_MULTIPLE_LISTING_SERVICE":
            return Provider.PROVIDER_COEUR_DALENE_MULTIPLE_LISTING_SERVICE;
        case 31087:
        case "PROVIDER_COLORADO_REAL_ESTATE_NETWORK_INC":
            return Provider.PROVIDER_COLORADO_REAL_ESTATE_NETWORK_INC;
        case 31088:
        case "PROVIDER_COLUMBIA":
            return Provider.PROVIDER_COLUMBIA;
        case 31089:
        case "PROVIDER_COLUMBIA_BOARD_OF_REALTORS":
            return Provider.PROVIDER_COLUMBIA_BOARD_OF_REALTORS;
        case 31090:
        case "PROVIDER_COLUMBIA_GREENE_AND_NORTHERN_DUTCHESS_MLS":
            return Provider.PROVIDER_COLUMBIA_GREENE_AND_NORTHERN_DUTCHESS_MLS;
        case 31091:
        case "PROVIDER_COLUMBUS_AND_CENTRAL_OHIO_MULTIPLE_LISTING_SERVICE":
            return Provider.PROVIDER_COLUMBUS_AND_CENTRAL_OHIO_MULTIPLE_LISTING_SERVICE;
        case 31092:
        case "PROVIDER_COLUMBUS_BOARD_OF_REALTORS":
            return Provider.PROVIDER_COLUMBUS_BOARD_OF_REALTORS;
        case 31093:
        case "PROVIDER_CONSOLIDATED_MLS_INC":
            return Provider.PROVIDER_CONSOLIDATED_MLS_INC;
        case 31094:
        case "PROVIDER_CONTRA_COSTA_AOR_BAY_EAST_AOR_AND_BRIDGE_MLS":
            return Provider.PROVIDER_CONTRA_COSTA_AOR_BAY_EAST_AOR_AND_BRIDGE_MLS;
        case 31095:
        case "PROVIDER_COOPERATIVE_ARKANSAS_REALTORS_MULTIPLE_LISTING_SERVICE":
            return Provider.PROVIDER_COOPERATIVE_ARKANSAS_REALTORS_MULTIPLE_LISTING_SERVICE;
        case 31096:
        case "PROVIDER_CORPUS_CHRISTI_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_CORPUS_CHRISTI_ASSOCIATION_OF_REALTORS;
        case 31097:
        case "PROVIDER_CREA":
            return Provider.PROVIDER_CREA;
        case 31098:
        case "PROVIDER_DAYTONA_BEACH_AREA_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_DAYTONA_BEACH_AREA_ASSOCIATION_OF_REALTORS;
        case 31099:
        case "PROVIDER_DAYTON_REALTORS_MLS":
            return Provider.PROVIDER_DAYTON_REALTORS_MLS;
        case 31100:
        case "PROVIDER_DEMO_MLS":
            return Provider.PROVIDER_DEMO_MLS;
        case 31101:
        case "PROVIDER_DES_MOINES_AREA_ASSOCIATION_OF_REALTORS_INC":
            return Provider.PROVIDER_DES_MOINES_AREA_ASSOCIATION_OF_REALTORS_INC;
        case 31102:
        case "PROVIDER_DIXIE_GILCHRIST_LEVY_COUNTIES_BOARD_OF_REALTORS":
            return Provider.PROVIDER_DIXIE_GILCHRIST_LEVY_COUNTIES_BOARD_OF_REALTORS;
        case 31103:
        case "PROVIDER_DOMINICAN_REPUBLIC":
            return Provider.PROVIDER_DOMINICAN_REPUBLIC;
        case 31104:
        case "PROVIDER_DUBLIN_BOARD_OF_REALTORS":
            return Provider.PROVIDER_DUBLIN_BOARD_OF_REALTORS;
        case 31105:
        case "PROVIDER_DUMMY_MLS_FOR_QA":
            return Provider.PROVIDER_DUMMY_MLS_FOR_QA;
        case 31106:
        case "PROVIDER_ELKO_COUNTY_BOARD_OF_REALTORS":
            return Provider.PROVIDER_ELKO_COUNTY_BOARD_OF_REALTORS;
        case 31107:
        case "PROVIDER_ELMIRACORNING_REGIONAL_BOARD_OF_REALTORS_MLS":
            return Provider.PROVIDER_ELMIRACORNING_REGIONAL_BOARD_OF_REALTORS_MLS;
        case 31108:
        case "PROVIDER_EMERALD_COAST_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_EMERALD_COAST_ASSOCIATION_OF_REALTORS;
        case 31109:
        case "PROVIDER_EMERALD_COAST_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY":
            return Provider.PROVIDER_EMERALD_COAST_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY;
        case 31110:
        case "PROVIDER_EXP_PORTAL1":
            return Provider.PROVIDER_EXP_PORTAL1;
        case 31111:
        case "PROVIDER_EXP_PORTAL10":
            return Provider.PROVIDER_EXP_PORTAL10;
        case 31112:
        case "PROVIDER_EXP_PORTAL11":
            return Provider.PROVIDER_EXP_PORTAL11;
        case 31113:
        case "PROVIDER_EXP_PORTAL12":
            return Provider.PROVIDER_EXP_PORTAL12;
        case 31114:
        case "PROVIDER_EXP_PORTAL13":
            return Provider.PROVIDER_EXP_PORTAL13;
        case 31115:
        case "PROVIDER_EXP_PORTAL14":
            return Provider.PROVIDER_EXP_PORTAL14;
        case 31116:
        case "PROVIDER_EXP_PORTAL15":
            return Provider.PROVIDER_EXP_PORTAL15;
        case 31117:
        case "PROVIDER_EXP_PORTAL18":
            return Provider.PROVIDER_EXP_PORTAL18;
        case 31118:
        case "PROVIDER_EXP_PORTAL19":
            return Provider.PROVIDER_EXP_PORTAL19;
        case 31119:
        case "PROVIDER_EXP_PORTAL2":
            return Provider.PROVIDER_EXP_PORTAL2;
        case 31120:
        case "PROVIDER_EXP_PORTAL20":
            return Provider.PROVIDER_EXP_PORTAL20;
        case 31121:
        case "PROVIDER_EXP_PORTAL21":
            return Provider.PROVIDER_EXP_PORTAL21;
        case 31122:
        case "PROVIDER_EXP_PORTAL22":
            return Provider.PROVIDER_EXP_PORTAL22;
        case 31123:
        case "PROVIDER_EXP_PORTAL23":
            return Provider.PROVIDER_EXP_PORTAL23;
        case 31124:
        case "PROVIDER_EXP_PORTAL24_SMART":
            return Provider.PROVIDER_EXP_PORTAL24_SMART;
        case 31125:
        case "PROVIDER_EXP_PORTAL24_CR_MLS":
            return Provider.PROVIDER_EXP_PORTAL24_CR_MLS;
        case 31126:
        case "PROVIDER_EXP_PORTAL3":
            return Provider.PROVIDER_EXP_PORTAL3;
        case 31127:
        case "PROVIDER_EXP_PORTAL4":
            return Provider.PROVIDER_EXP_PORTAL4;
        case 31128:
        case "PROVIDER_EXP_PORTAL5":
            return Provider.PROVIDER_EXP_PORTAL5;
        case 31129:
        case "PROVIDER_EXP_PORTAL6":
            return Provider.PROVIDER_EXP_PORTAL6;
        case 31130:
        case "PROVIDER_EXP_PORTAL7":
            return Provider.PROVIDER_EXP_PORTAL7;
        case 31131:
        case "PROVIDER_EXP_PORTAL8":
            return Provider.PROVIDER_EXP_PORTAL8;
        case 31132:
        case "PROVIDER_EXP_PORTAL9":
            return Provider.PROVIDER_EXP_PORTAL9;
        case 31133:
        case "PROVIDER_FARGO_MOORHEAD_AREA_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_FARGO_MOORHEAD_AREA_ASSOCIATION_OF_REALTORS;
        case 31134:
        case "PROVIDER_FIRELANDS_MLS":
            return Provider.PROVIDER_FIRELANDS_MLS;
        case 31135:
        case "PROVIDER_FIRST_MULTIPLE_LISTING_SERVICE":
            return Provider.PROVIDER_FIRST_MULTIPLE_LISTING_SERVICE;
        case 31136:
        case "PROVIDER_FLINT_HILLS_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_FLINT_HILLS_ASSOCIATION_OF_REALTORS;
        case 31137:
        case "PROVIDER_FLORIDA_KEYS_BOARD_OF_REALTORS":
            return Provider.PROVIDER_FLORIDA_KEYS_BOARD_OF_REALTORS;
        case 31138:
        case "PROVIDER_FORT_DODGE_MLS":
            return Provider.PROVIDER_FORT_DODGE_MLS;
        case 31139:
        case "PROVIDER_FRANCE":
            return Provider.PROVIDER_FRANCE;
        case 31140:
        case "PROVIDER_FRESNO_MLS":
            return Provider.PROVIDER_FRESNO_MLS;
        case 31141:
        case "PROVIDER_GALVESTON_ASSOCIATION_OF_REALTORS_MLS":
            return Provider.PROVIDER_GALVESTON_ASSOCIATION_OF_REALTORS_MLS;
        case 31142:
        case "PROVIDER_GARDEN_STATE_MLS":
            return Provider.PROVIDER_GARDEN_STATE_MLS;
        case 31143:
        case "PROVIDER_GARDEN_STATE_MLS_EXP_PORTAL_ONLY":
            return Provider.PROVIDER_GARDEN_STATE_MLS_EXP_PORTAL_ONLY;
        case 31144:
        case "PROVIDER_GEORGIA_MULTIPLE_LISTING_SERVICE":
            return Provider.PROVIDER_GEORGIA_MULTIPLE_LISTING_SERVICE;
        case 31145:
        case "PROVIDER_GERMANY":
            return Provider.PROVIDER_GERMANY;
        case 31146:
        case "PROVIDER_GLOBAL_MLS_INC":
            return Provider.PROVIDER_GLOBAL_MLS_INC;
        case 31147:
        case "PROVIDER_GOLDSBORO_WAYNE_COUNTY_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_GOLDSBORO_WAYNE_COUNTY_ASSOCIATION_OF_REALTORS;
        case 31148:
        case "PROVIDER_GRAND_COUNTY_BOARD_OF_REALTORS":
            return Provider.PROVIDER_GRAND_COUNTY_BOARD_OF_REALTORS;
        case 31149:
        case "PROVIDER_GRAND_ISLAND_BOARD_OF_REALTORS":
            return Provider.PROVIDER_GRAND_ISLAND_BOARD_OF_REALTORS;
        case 31150:
        case "PROVIDER_GRAND_JUNCTION_AREA_REALTORS_ASSOCIATION_MLS":
            return Provider.PROVIDER_GRAND_JUNCTION_AREA_REALTORS_ASSOCIATION_MLS;
        case 31151:
        case "PROVIDER_GREATER_ALABAMA_MLS":
            return Provider.PROVIDER_GREATER_ALABAMA_MLS;
        case 31152:
        case "PROVIDER_GREATER_ANTELOPE_VALLEY_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_GREATER_ANTELOPE_VALLEY_ASSOCIATION_OF_REALTORS;
        case 31153:
        case "PROVIDER_GREATER_AUGUSTA_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_GREATER_AUGUSTA_ASSOCIATION_OF_REALTORS;
        case 31154:
        case "PROVIDER_GREATER_BATON_ROUGE_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_GREATER_BATON_ROUGE_ASSOCIATION_OF_REALTORS;
        case 31155:
        case "PROVIDER_GREATER_CHATTANOOGA_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_GREATER_CHATTANOOGA_ASSOCIATION_OF_REALTORS;
        case 31156:
        case "PROVIDER_GREATER_CHATTANOOGA_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY":
            return Provider.PROVIDER_GREATER_CHATTANOOGA_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY;
        case 31157:
        case "PROVIDER_GREATER_EL_PASO_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_GREATER_EL_PASO_ASSOCIATION_OF_REALTORS;
        case 31158:
        case "PROVIDER_GREATER_ERIE_BOARD_OF_REALTORS_MLS":
            return Provider.PROVIDER_GREATER_ERIE_BOARD_OF_REALTORS_MLS;
        case 31159:
        case "PROVIDER_GREATER_GREENVILLE_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_GREATER_GREENVILLE_ASSOCIATION_OF_REALTORS;
        case 31160:
        case "PROVIDER_GREATER_LAS_VEGAS_ASSOCIATION_OF_REALTORS_INC":
            return Provider.PROVIDER_GREATER_LAS_VEGAS_ASSOCIATION_OF_REALTORS_INC;
        case 31161:
        case "PROVIDER_GREATER_LEHIGH_VALLEY_REALTORS":
            return Provider.PROVIDER_GREATER_LEHIGH_VALLEY_REALTORS;
        case 31162:
        case "PROVIDER_GREATER_LOUISVILLE_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_GREATER_LOUISVILLE_ASSOCIATION_OF_REALTORS;
        case 31163:
        case "PROVIDER_GREATER_MASON_CITY_BOARD_OF_REALTORS":
            return Provider.PROVIDER_GREATER_MASON_CITY_BOARD_OF_REALTORS;
        case 31164:
        case "PROVIDER_GREATER_MCALLEN_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_GREATER_MCALLEN_ASSOCIATION_OF_REALTORS;
        case 31411:
        case "PROVIDER_GREATER_REGIONAL_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_GREATER_REGIONAL_ASSOCIATION_OF_REALTORS;
        case 31165:
        case "PROVIDER_GREATER_NORTHWEST_INDIANA_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_GREATER_NORTHWEST_INDIANA_ASSOCIATION_OF_REALTORS;
        case 31166:
        case "PROVIDER_GREATER_OWENSBORO_REALTOR_ASSOCIATION":
            return Provider.PROVIDER_GREATER_OWENSBORO_REALTOR_ASSOCIATION;
        case 31167:
        case "PROVIDER_GREATER_PORTSMOUTH_AREA_MULTIPLE_LISTING_SERVICE":
            return Provider.PROVIDER_GREATER_PORTSMOUTH_AREA_MULTIPLE_LISTING_SERVICE;
        case 31168:
        case "PROVIDER_GREATER_SOUTHERN_MLS":
            return Provider.PROVIDER_GREATER_SOUTHERN_MLS;
        case 31169:
        case "PROVIDER_GREATER_TYLER_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_GREATER_TYLER_ASSOCIATION_OF_REALTORS;
        case 31170:
        case "PROVIDER_GREATER_TYLER_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY":
            return Provider.PROVIDER_GREATER_TYLER_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY;
        case 31171:
        case "PROVIDER_GREAT_PLAINS_REGIONAL_MLS":
            return Provider.PROVIDER_GREAT_PLAINS_REGIONAL_MLS;
        case 31172:
        case "PROVIDER_GREAT_SMOKY_MOUNTAINS_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_GREAT_SMOKY_MOUNTAINS_ASSOCIATION_OF_REALTORS;
        case 31173:
        case "PROVIDER_GREECE":
            return Provider.PROVIDER_GREECE;
        case 31174:
        case "PROVIDER_GREENVILLEPITT_ASSOCIATION_OF_REALTORS_MLS":
            return Provider.PROVIDER_GREENVILLEPITT_ASSOCIATION_OF_REALTORS_MLS;
        case 31175:
        case "PROVIDER_GREENWICH_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_GREENWICH_ASSOCIATION_OF_REALTORS;
        case 31176:
        case "PROVIDER_GULF_COAST_MULTIPLE_LISTING_SERVICE":
            return Provider.PROVIDER_GULF_COAST_MULTIPLE_LISTING_SERVICE;
        case 31177:
        case "PROVIDER_GULF_SOUTH_REAL_ESTATE_INFORMATION_NETWORK":
            return Provider.PROVIDER_GULF_SOUTH_REAL_ESTATE_INFORMATION_NETWORK;
        case 31178:
        case "PROVIDER_HATTIESBURG_AREA_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_HATTIESBURG_AREA_ASSOCIATION_OF_REALTORS;
        case 31179:
        case "PROVIDER_HAWAII_INFORMATION_SERVICE":
            return Provider.PROVIDER_HAWAII_INFORMATION_SERVICE;
        case 31180:
        case "PROVIDER_HEARTLAND_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_HEARTLAND_ASSOCIATION_OF_REALTORS;
        case 31181:
        case "PROVIDER_HEARTLAND_MLS":
            return Provider.PROVIDER_HEARTLAND_MLS;
        case 31182:
        case "PROVIDER_HEART_OF_KENTUCKY_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_HEART_OF_KENTUCKY_ASSOCIATION_OF_REALTORS;
        case 31183:
        case "PROVIDER_HERNANDO_COUNTY_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_HERNANDO_COUNTY_ASSOCIATION_OF_REALTORS;
        case 31184:
        case "PROVIDER_HIGH_COUNTRY_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_HIGH_COUNTRY_ASSOCIATION_OF_REALTORS;
        case 31185:
        case "PROVIDER_HIGHLAND_LAKES_ASSOCIATION_OF_REALTORS_MLS":
            return Provider.PROVIDER_HIGHLAND_LAKES_ASSOCIATION_OF_REALTORS_MLS;
        case 31186:
        case "PROVIDER_HIGHLANDS_CASHIERS_BOARD_OF_REALTORS":
            return Provider.PROVIDER_HIGHLANDS_CASHIERS_BOARD_OF_REALTORS;
        case 31187:
        case "PROVIDER_HINESVILLE_AREA_BOARD_OF_REALTORS_INC_MLS":
            return Provider.PROVIDER_HINESVILLE_AREA_BOARD_OF_REALTORS_INC_MLS;
        case 31188:
        case "PROVIDER_HONOLULU_BOARD_OF_REALTORS":
            return Provider.PROVIDER_HONOLULU_BOARD_OF_REALTORS;
        case 31189:
        case "PROVIDER_HONOLULU_BOARD_OF_REALTORS_EXP":
            return Provider.PROVIDER_HONOLULU_BOARD_OF_REALTORS_EXP;
        case 31190:
        case "PROVIDER_HOPKINSVILLE_CHRISTIAN_COUNTY_BOARD_OF_REALTORS":
            return Provider.PROVIDER_HOPKINSVILLE_CHRISTIAN_COUNTY_BOARD_OF_REALTORS;
        case 31191:
        case "PROVIDER_HOT_SPRINGS_BOARD_OF_REALTORS":
            return Provider.PROVIDER_HOT_SPRINGS_BOARD_OF_REALTORS;
        case 31192:
        case "PROVIDER_HOUSTON_REALTORS_INFORMATION_SERVICE":
            return Provider.PROVIDER_HOUSTON_REALTORS_INFORMATION_SERVICE;
        case 31193:
        case "PROVIDER_HUDSON_COUNTY_MULTIPLE_LISTING_SERVICE":
            return Provider.PROVIDER_HUDSON_COUNTY_MULTIPLE_LISTING_SERVICE;
        case 31194:
        case "PROVIDER_HUMBOLDT_COUNTY_MLS":
            return Provider.PROVIDER_HUMBOLDT_COUNTY_MLS;
        case 31195:
        case "PROVIDER_INCLINE_VILLAGE_BOARD_OF_REALTORS":
            return Provider.PROVIDER_INCLINE_VILLAGE_BOARD_OF_REALTORS;
        case 31196:
        case "PROVIDER_INDIA":
            return Provider.PROVIDER_INDIA;
        case 31197:
        case "PROVIDER_INDIANA_REGIONAL_MLS":
            return Provider.PROVIDER_INDIANA_REGIONAL_MLS;
        case 31198:
        case "PROVIDER_INFORMATION_AND_REAL_ESTATE_SERVICES":
            return Provider.PROVIDER_INFORMATION_AND_REAL_ESTATE_SERVICES;
        case 31199:
        case "PROVIDER_INTERMOUNTAIN_MULTIPLE_LISTING_SERVICE":
            return Provider.PROVIDER_INTERMOUNTAIN_MULTIPLE_LISTING_SERVICE;
        case 31200:
        case "PROVIDER_IOWA_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_IOWA_ASSOCIATION_OF_REALTORS;
        case 31201:
        case "PROVIDER_IOWA_GREAT_LAKES_BOARD_OF_REALTORS":
            return Provider.PROVIDER_IOWA_GREAT_LAKES_BOARD_OF_REALTORS;
        case 31202:
        case "PROVIDER_ISRAEL":
            return Provider.PROVIDER_ISRAEL;
        case 31203:
        case "PROVIDER_ITALY":
            return Provider.PROVIDER_ITALY;
        case 31204:
        case "PROVIDER_JACKSONVILLE_BOARD_OF_REALTORS_NC":
            return Provider.PROVIDER_JACKSONVILLE_BOARD_OF_REALTORS_NC;
        case 31205:
        case "PROVIDER_JEFFERSON_CITY_AREA_BOARD_OF_REALTORS":
            return Provider.PROVIDER_JEFFERSON_CITY_AREA_BOARD_OF_REALTORS;
        case 31206:
        case "PROVIDER_KANAB_UT_MLS":
            return Provider.PROVIDER_KANAB_UT_MLS;
        case 31207:
        case "PROVIDER_KANAWHA_VALLEY_BOARD_OF_REALTORS":
            return Provider.PROVIDER_KANAWHA_VALLEY_BOARD_OF_REALTORS;
        case 31208:
        case "PROVIDER_KEY_WEST_ASSOCIATION_OF_REALTORS_MLS":
            return Provider.PROVIDER_KEY_WEST_ASSOCIATION_OF_REALTORS_MLS;
        case 31209:
        case "PROVIDER_KNOXVILLE_AREA_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_KNOXVILLE_AREA_ASSOCIATION_OF_REALTORS;
        case 31210:
        case "PROVIDER_LAKE_COUNTRY_BOARD_OF_REALTORS":
            return Provider.PROVIDER_LAKE_COUNTRY_BOARD_OF_REALTORS;
        case 31211:
        case "PROVIDER_LAKE_HAVASU_ASSOCIATION_MLS":
            return Provider.PROVIDER_LAKE_HAVASU_ASSOCIATION_MLS;
        case 31212:
        case "PROVIDER_LAKE_SUPERIOR_AREA_REALTORS":
            return Provider.PROVIDER_LAKE_SUPERIOR_AREA_REALTORS;
        case 31213:
        case "PROVIDER_LAKEWAY_AREA_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_LAKEWAY_AREA_ASSOCIATION_OF_REALTORS;
        case 31214:
        case "PROVIDER_LAWRENCE_BOARD_OF_REALTORS":
            return Provider.PROVIDER_LAWRENCE_BOARD_OF_REALTORS;
        case 31215:
        case "PROVIDER_LEE_COUNTY_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_LEE_COUNTY_ASSOCIATION_OF_REALTORS;
        case 31216:
        case "PROVIDER_LINCOLN_COUNTY_BOARD_OF_REALTORS":
            return Provider.PROVIDER_LINCOLN_COUNTY_BOARD_OF_REALTORS;
        case 31217:
        case "PROVIDER_LONGLEAF_PINE_REALTORS":
            return Provider.PROVIDER_LONGLEAF_PINE_REALTORS;
        case 31218:
        case "PROVIDER_LONGVIEW_AREA_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_LONGVIEW_AREA_ASSOCIATION_OF_REALTORS;
        case 31219:
        case "PROVIDER_LOWCOUNTRY_REGIONAL_MULTIPLE_LISTING_SERVICE_INC":
            return Provider.PROVIDER_LOWCOUNTRY_REGIONAL_MULTIPLE_LISTING_SERVICE_INC;
        case 31220:
        case "PROVIDER_LUBBOCK_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_LUBBOCK_ASSOCIATION_OF_REALTORS;
        case 31221:
        case "PROVIDER_LYNCHBURG_VIRGINIA_MLS":
            return Provider.PROVIDER_LYNCHBURG_VIRGINIA_MLS;
        case 31222:
        case "PROVIDER_MAINE_REAL_ESTATE_INFORMATION_SYSTEM_INC":
            return Provider.PROVIDER_MAINE_REAL_ESTATE_INFORMATION_SYSTEM_INC;
        case 31223:
        case "PROVIDER_MANSFIELD_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_MANSFIELD_ASSOCIATION_OF_REALTORS;
        case 31224:
        case "PROVIDER_MARCO_ISLAND_AREA_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_MARCO_ISLAND_AREA_ASSOCIATION_OF_REALTORS;
        case 31225:
        case "PROVIDER_MARTHAS_VINEYARD_MLS":
            return Provider.PROVIDER_MARTHAS_VINEYARD_MLS;
        case 31226:
        case "PROVIDER_MARTIN_COUNTY_REALTORS_OF_THE_TREASURE_COAST":
            return Provider.PROVIDER_MARTIN_COUNTY_REALTORS_OF_THE_TREASURE_COAST;
        case 31227:
        case "PROVIDER_MEMPHIS_AREA_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_MEMPHIS_AREA_ASSOCIATION_OF_REALTORS;
        case 31228:
        case "PROVIDER_MERCER_TAZEWELL_CO_BOR":
            return Provider.PROVIDER_MERCER_TAZEWELL_CO_BOR;
        case 31229:
        case "PROVIDER_METROLIST_CA":
            return Provider.PROVIDER_METROLIST_CA;
        case 31230:
        case "PROVIDER_METRO_MLS":
            return Provider.PROVIDER_METRO_MLS;
        case 31231:
        case "PROVIDER_MEXICO":
            return Provider.PROVIDER_MEXICO;
        case 31232:
        case "PROVIDER_MIBOR_SERVICE_CORPORATION":
            return Provider.PROVIDER_MIBOR_SERVICE_CORPORATION;
        case 31233:
        case "PROVIDER_MICHIGAN_REGIONAL_INFORMATION_CENTER":
            return Provider.PROVIDER_MICHIGAN_REGIONAL_INFORMATION_CENTER;
        case 31234:
        case "PROVIDER_MID_AMERICA_REGIONAL_INFORMATION_SYSTEMS":
            return Provider.PROVIDER_MID_AMERICA_REGIONAL_INFORMATION_SYSTEMS;
        case 31235:
        case "PROVIDER_MIDDLE_GEORGIA_MLS":
            return Provider.PROVIDER_MIDDLE_GEORGIA_MLS;
        case 31236:
        case "PROVIDER_MIDDLE_TENNESSEE_REGIONAL_MLS":
            return Provider.PROVIDER_MIDDLE_TENNESSEE_REGIONAL_MLS;
        case 31237:
        case "PROVIDER_MIDHUDSON_MULTIPLE_LISTING_SERVICE":
            return Provider.PROVIDER_MIDHUDSON_MULTIPLE_LISTING_SERVICE;
        case 31238:
        case "PROVIDER_MIDWEST_REAL_ESTATE_DATA":
            return Provider.PROVIDER_MIDWEST_REAL_ESTATE_DATA;
        case 31239:
        case "PROVIDER_MILLEDGEVILLE_MLS":
            return Provider.PROVIDER_MILLEDGEVILLE_MLS;
        case 31240:
        case "PROVIDER_MLS_LISTINGS_INC":
            return Provider.PROVIDER_MLS_LISTINGS_INC;
        case 31241:
        case "PROVIDER_MLS_NOW":
            return Provider.PROVIDER_MLS_NOW;
        case 31242:
        case "PROVIDER_MLS_OF_CENTRAL_OREGON":
            return Provider.PROVIDER_MLS_OF_CENTRAL_OREGON;
        case 31243:
        case "PROVIDER_MLS_OF_GREATER_CINCINNATI_INC":
            return Provider.PROVIDER_MLS_OF_GREATER_CINCINNATI_INC;
        case 31244:
        case "PROVIDER_MLS_OF_YAKIMA_ASSOCIATION":
            return Provider.PROVIDER_MLS_OF_YAKIMA_ASSOCIATION;
        case 31245:
        case "PROVIDER_MLS_PROPERTY_INFORMATION_NETWORK":
            return Provider.PROVIDER_MLS_PROPERTY_INFORMATION_NETWORK;
        case 31246:
        case "PROVIDER_MLS_TECHNOLOGY":
            return Provider.PROVIDER_MLS_TECHNOLOGY;
        case 31247:
        case "PROVIDER_MLS_UNITED":
            return Provider.PROVIDER_MLS_UNITED;
        case 31248:
        case "PROVIDER_MONMOUTHOCEAN_MULTIPLE_LISTING_SERVICE":
            return Provider.PROVIDER_MONMOUTHOCEAN_MULTIPLE_LISTING_SERVICE;
        case 31249:
        case "PROVIDER_MONTANA_REGIONAL_MLS":
            return Provider.PROVIDER_MONTANA_REGIONAL_MLS;
        case 31250:
        case "PROVIDER_MONTGOMERY_AREA_ASSOCIATION_OF_REALTORS_MLS":
            return Provider.PROVIDER_MONTGOMERY_AREA_ASSOCIATION_OF_REALTORS_MLS;
        case 31251:
        case "PROVIDER_MOUNTAIN_LAKES_BOARD_OF_REALTORS":
            return Provider.PROVIDER_MOUNTAIN_LAKES_BOARD_OF_REALTORS;
        case 31252:
        case "PROVIDER_MT_RUSHMORE_AREA_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_MT_RUSHMORE_AREA_ASSOCIATION_OF_REALTORS;
        case 31253:
        case "PROVIDER_MULTIPLE_LISTING_SERVICE_MIREALSOURCE":
            return Provider.PROVIDER_MULTIPLE_LISTING_SERVICE_MIREALSOURCE;
        case 31254:
        case "PROVIDER_MULTIPLE_LISTING_SERVICE_OF_HILTON_HEAD_ISLAND_INC":
            return Provider.PROVIDER_MULTIPLE_LISTING_SERVICE_OF_HILTON_HEAD_ISLAND_INC;
        case 31255:
        case "PROVIDER_MULTIPLE_LISTING_SERVICE_OF_SOUTHERN_ARIZONA":
            return Provider.PROVIDER_MULTIPLE_LISTING_SERVICE_OF_SOUTHERN_ARIZONA;
        case 31256:
        case "PROVIDER_NAPLES_AREA_BOARD_OF_REALTORS":
            return Provider.PROVIDER_NAPLES_AREA_BOARD_OF_REALTORS;
        case 31257:
        case "PROVIDER_NEUSE_RIVER_REGION_MLS_INC":
            return Provider.PROVIDER_NEUSE_RIVER_REGION_MLS_INC;
        case 31258:
        case "PROVIDER_NEW_CANAAN_BOARD_OF_REALTORS":
            return Provider.PROVIDER_NEW_CANAAN_BOARD_OF_REALTORS;
        case 31259:
        case "PROVIDER_NEW_JERSEY_MLS":
            return Provider.PROVIDER_NEW_JERSEY_MLS;
        case 31260:
        case "PROVIDER_NEW_SMYRNA_BEACH_BOARD_OF_REALTORS":
            return Provider.PROVIDER_NEW_SMYRNA_BEACH_BOARD_OF_REALTORS;
        case 31261:
        case "PROVIDER_NEW_YORK_STATE_ALLIANCE_OF_MLSS":
            return Provider.PROVIDER_NEW_YORK_STATE_ALLIANCE_OF_MLSS;
        case 31262:
        case "PROVIDER_NEW_ZEALAND":
            return Provider.PROVIDER_NEW_ZEALAND;
        case 31263:
        case "PROVIDER_NORTH_CENTRAL_WEST_VIRGINIA_REAL_ESTATE_INFORMATION_NETWORK":
            return Provider.PROVIDER_NORTH_CENTRAL_WEST_VIRGINIA_REAL_ESTATE_INFORMATION_NETWORK;
        case 31264:
        case "PROVIDER_NORTHEAST_ARKANSAS_BOARD_OF_REALTORS":
            return Provider.PROVIDER_NORTHEAST_ARKANSAS_BOARD_OF_REALTORS;
        case 31265:
        case "PROVIDER_NORTHEAST_GEORGIA_BOARD_OF_REALTORS":
            return Provider.PROVIDER_NORTHEAST_GEORGIA_BOARD_OF_REALTORS;
        case 31266:
        case "PROVIDER_NORTHEAST_IOWA_REGIONAL_BOARD_OF_REALTORS":
            return Provider.PROVIDER_NORTHEAST_IOWA_REGIONAL_BOARD_OF_REALTORS;
        case 31267:
        case "PROVIDER_NORTHEAST_LOUISIANA_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_NORTHEAST_LOUISIANA_ASSOCIATION_OF_REALTORS;
        case 31268:
        case "PROVIDER_NORTHEAST_OKLAHOMA_BOARD_OF_REALTORS":
            return Provider.PROVIDER_NORTHEAST_OKLAHOMA_BOARD_OF_REALTORS;
        case 31269:
        case "PROVIDER_NORTHERN_ARIZONA_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_NORTHERN_ARIZONA_ASSOCIATION_OF_REALTORS;
        case 31270:
        case "PROVIDER_NORTHERN_GREAT_LAKES_REALTORS_MLS":
            return Provider.PROVIDER_NORTHERN_GREAT_LAKES_REALTORS_MLS;
        case 31271:
        case "PROVIDER_NORTHERN_KENTUCKY_MULTIPLE_LISTING_SERVICE":
            return Provider.PROVIDER_NORTHERN_KENTUCKY_MULTIPLE_LISTING_SERVICE;
        case 31272:
        case "PROVIDER_NORTHERN_NEVADA_REGIONAL_MLS_INC":
            return Provider.PROVIDER_NORTHERN_NEVADA_REGIONAL_MLS_INC;
        case 31273:
        case "PROVIDER_NORTH_FLORIDA_MLS":
            return Provider.PROVIDER_NORTH_FLORIDA_MLS;
        case 31274:
        case "PROVIDER_NORTH_SANTA_BARBARA_COUNTY_REGIONAL_MLS":
            return Provider.PROVIDER_NORTH_SANTA_BARBARA_COUNTY_REGIONAL_MLS;
        case 31275:
        case "PROVIDER_NORTHSTARMLS":
            return Provider.PROVIDER_NORTHSTARMLS;
        case 31276:
        case "PROVIDER_NORTH_TEXAS_REAL_ESTATE_INFORMATION_SYSTEMS":
            return Provider.PROVIDER_NORTH_TEXAS_REAL_ESTATE_INFORMATION_SYSTEMS;
        case 31277:
        case "PROVIDER_NORTHWEST_ARKANSAS_BOARD_OF_REALTORS":
            return Provider.PROVIDER_NORTHWEST_ARKANSAS_BOARD_OF_REALTORS;
        case 31278:
        case "PROVIDER_NORTHWESTERN_WISCONSIN_MULTIPLE_LISTING_SERVICE":
            return Provider.PROVIDER_NORTHWESTERN_WISCONSIN_MULTIPLE_LISTING_SERVICE;
        case 31279:
        case "PROVIDER_NORTHWEST_IOWA_MLS":
            return Provider.PROVIDER_NORTHWEST_IOWA_MLS;
        case 31280:
        case "PROVIDER_NORTHWEST_MISSISSIPPI_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_NORTHWEST_MISSISSIPPI_ASSOCIATION_OF_REALTORS;
        case 31281:
        case "PROVIDER_NORTHWEST_MLS":
            return Provider.PROVIDER_NORTHWEST_MLS;
        case 31282:
        case "PROVIDER_NORTHWEST_OHIO_REAL_ESTATE_INFORMATION_SYSTEMS":
            return Provider.PROVIDER_NORTHWEST_OHIO_REAL_ESTATE_INFORMATION_SYSTEMS;
        case 31283:
        case "PROVIDER_NORTHWOODS_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_NORTHWOODS_ASSOCIATION_OF_REALTORS;
        case 31284:
        case "PROVIDER_OLD_KENTUCKY_HOME_BOARD_OF_REALTORS":
            return Provider.PROVIDER_OLD_KENTUCKY_HOME_BOARD_OF_REALTORS;
        case 31285:
        case "PROVIDER_ONEKEY_MLS":
            return Provider.PROVIDER_ONEKEY_MLS;
        case 31286:
        case "PROVIDER_OUTER_BANKS_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_OUTER_BANKS_ASSOCIATION_OF_REALTORS;
        case 31287:
        case "PROVIDER_OZARK_GATEWAY_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_OZARK_GATEWAY_ASSOCIATION_OF_REALTORS;
        case 31288:
        case "PROVIDER_PACIFIC_REGIONAL_MLS":
            return Provider.PROVIDER_PACIFIC_REGIONAL_MLS;
        case 31289:
        case "PROVIDER_PAGE_LAKE_POWELL_MLS":
            return Provider.PROVIDER_PAGE_LAKE_POWELL_MLS;
        case 31290:
        case "PROVIDER_PALESTINE_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_PALESTINE_ASSOCIATION_OF_REALTORS;
        case 31291:
        case "PROVIDER_PALM_BEACH_BOARD_OF_REALTORS":
            return Provider.PROVIDER_PALM_BEACH_BOARD_OF_REALTORS;
        case 31292:
        case "PROVIDER_PALMETTO_MULTIPLE_LISTING_SERVICE":
            return Provider.PROVIDER_PALMETTO_MULTIPLE_LISTING_SERVICE;
        case 31293:
        case "PROVIDER_PANAMA":
            return Provider.PROVIDER_PANAMA;
        case 31294:
        case "PROVIDER_PARK_CITY_BOARD_OF_REALTORS":
            return Provider.PROVIDER_PARK_CITY_BOARD_OF_REALTORS;
        case 31295:
        case "PROVIDER_PEARL_RIVER_COUNTY_BOARD_OF_REALTORS":
            return Provider.PROVIDER_PEARL_RIVER_COUNTY_BOARD_OF_REALTORS;
        case 31296:
        case "PROVIDER_PENSACOLA_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_PENSACOLA_ASSOCIATION_OF_REALTORS;
        case 31297:
        case "PROVIDER_PERMIAN_BASIN_BOARD_OF_REALTORS":
            return Provider.PROVIDER_PERMIAN_BASIN_BOARD_OF_REALTORS;
        case 31298:
        case "PROVIDER_PIKES_PEAK_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_PIKES_PEAK_ASSOCIATION_OF_REALTORS;
        case 31299:
        case "PROVIDER_PIKEWAYNE_ASSOCIATION_OF_REALTORS_MLS":
            return Provider.PROVIDER_PIKEWAYNE_ASSOCIATION_OF_REALTORS_MLS;
        case 31300:
        case "PROVIDER_POCONO_MOUNTAINS_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_POCONO_MOUNTAINS_ASSOCIATION_OF_REALTORS;
        case 31301:
        case "PROVIDER_PORT_NECHES_PORT_ARTHUR_NEDERLAND_BOARD_OF_REALTORS_INC_MLS":
            return Provider.PROVIDER_PORT_NECHES_PORT_ARTHUR_NEDERLAND_BOARD_OF_REALTORS_INC_MLS;
        case 31302:
        case "PROVIDER_PORTUGAL":
            return Provider.PROVIDER_PORTUGAL;
        case 31303:
        case "PROVIDER_PRESCOTT_AREA_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_PRESCOTT_AREA_ASSOCIATION_OF_REALTORS;
        case 31304:
        case "PROVIDER_PRIMEMLS":
            return Provider.PROVIDER_PRIMEMLS;
        case 31305:
        case "PROVIDER_PUEBLO_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_PUEBLO_ASSOCIATION_OF_REALTORS;
        case 31306:
        case "PROVIDER_PUERTO_RICO":
            return Provider.PROVIDER_PUERTO_RICO;
        case 31307:
        case "PROVIDER_QAMLS2":
            return Provider.PROVIDER_QAMLS2;
        case 31308:
        case "PROVIDER_QAMLS3":
            return Provider.PROVIDER_QAMLS3;
        case 31309:
        case "PROVIDER_QAMLS4":
            return Provider.PROVIDER_QAMLS4;
        case 31310:
        case "PROVIDER_RANDOLPH_COUNTY_BOARD_OF_REALTORS":
            return Provider.PROVIDER_RANDOLPH_COUNTY_BOARD_OF_REALTORS;
        case 31311:
        case "PROVIDER_RANGE_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_RANGE_ASSOCIATION_OF_REALTORS;
        case 31312:
        case "PROVIDER_REALCOMP_LIMITED_II":
            return Provider.PROVIDER_REALCOMP_LIMITED_II;
        case 31313:
        case "PROVIDER_REAL_ESTATE_INFORMATION_NETWORK_INC":
            return Provider.PROVIDER_REAL_ESTATE_INFORMATION_NETWORK_INC;
        case 31314:
        case "PROVIDER_REALMLS":
            return Provider.PROVIDER_REALMLS;
        case 31315:
        case "PROVIDER_REALTOR_ASSOCIATION_OF_ACADIANA":
            return Provider.PROVIDER_REALTOR_ASSOCIATION_OF_ACADIANA;
        case 31316:
        case "PROVIDER_REALTOR_ASSOCIATION_OF_FRANKLIN_AND_GULF_COUNTIES":
            return Provider.PROVIDER_REALTOR_ASSOCIATION_OF_FRANKLIN_AND_GULF_COUNTIES;
        case 31317:
        case "PROVIDER_REALTOR_ASSOCIATION_OF_NORTHEAST_WISCONSIN":
            return Provider.PROVIDER_REALTOR_ASSOCIATION_OF_NORTHEAST_WISCONSIN;
        case 31318:
        case "PROVIDER_REALTOR_ASSOCIATION_OF_SOUTHERN_KENTUCKY_INC":
            return Provider.PROVIDER_REALTOR_ASSOCIATION_OF_SOUTHERN_KENTUCKY_INC;
        case 31319:
        case "PROVIDER_REALTOR_ASSOCIATION_OF_SOUTHERN_MINNESOTA":
            return Provider.PROVIDER_REALTOR_ASSOCIATION_OF_SOUTHERN_MINNESOTA;
        case 31320:
        case "PROVIDER_REALTOR_ASSOCIATION_OF_THE_SIOUX_EMPIRE_MLS":
            return Provider.PROVIDER_REALTOR_ASSOCIATION_OF_THE_SIOUX_EMPIRE_MLS;
        case 31321:
        case "PROVIDER_REALTORS_ASSOCIATION_OF_CITRUS_COUNTY":
            return Provider.PROVIDER_REALTORS_ASSOCIATION_OF_CITRUS_COUNTY;
        case 31322:
        case "PROVIDER_REALTORS_ASSOCIATION_OF_INDIAN_RIVER_COUNTY":
            return Provider.PROVIDER_REALTORS_ASSOCIATION_OF_INDIAN_RIVER_COUNTY;
        case 31323:
        case "PROVIDER_REALTORS_ASSOCIATION_OF_MAUI_INC":
            return Provider.PROVIDER_REALTORS_ASSOCIATION_OF_MAUI_INC;
        case 31324:
        case "PROVIDER_RECOLORADO":
            return Provider.PROVIDER_RECOLORADO;
        case 31325:
        case "PROVIDER_REGIONAL_MULTIPLE_LISTING_SERVICES":
            return Provider.PROVIDER_REGIONAL_MULTIPLE_LISTING_SERVICES;
        case 31326:
        case "PROVIDER_RIDGECREST_AREA_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_RIDGECREST_AREA_ASSOCIATION_OF_REALTORS;
        case 31327:
        case "PROVIDER_RIVER_COUNTIES_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_RIVER_COUNTIES_ASSOCIATION_OF_REALTORS;
        case 31328:
        case "PROVIDER_RMLS_ALLIANCE_LLC":
            return Provider.PROVIDER_RMLS_ALLIANCE_LLC;
        case 31329:
        case "PROVIDER_ROANOKE_VALLEY_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_ROANOKE_VALLEY_ASSOCIATION_OF_REALTORS;
        case 31330:
        case "PROVIDER_ROCKFORD_AREA_MLS":
            return Provider.PROVIDER_ROCKFORD_AREA_MLS;
        case 31331:
        case "PROVIDER_ROCKY_MOUNT_AREA_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_ROCKY_MOUNT_AREA_ASSOCIATION_OF_REALTORS;
        case 31332:
        case "PROVIDER_ROYAL_PALM_COAST_REALTOR_ASSOCIATION":
            return Provider.PROVIDER_ROYAL_PALM_COAST_REALTOR_ASSOCIATION;
        case 31333:
        case "PROVIDER_RUIDOSOLINCOLN_COUNTY_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_RUIDOSOLINCOLN_COUNTY_ASSOCIATION_OF_REALTORS;
        case 31334:
        case "PROVIDER_RUSSELLVILLE_BOARD_OF_REALTORS":
            return Provider.PROVIDER_RUSSELLVILLE_BOARD_OF_REALTORS;
        case 31335:
        case "PROVIDER_SAN_ANGELO_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_SAN_ANGELO_ASSOCIATION_OF_REALTORS;
        case 31336:
        case "PROVIDER_SAN_ANTONIO_BOARD_OF_REALTORS":
            return Provider.PROVIDER_SAN_ANTONIO_BOARD_OF_REALTORS;
        case 31337:
        case "PROVIDER_SAN_DIEGO_MLS":
            return Provider.PROVIDER_SAN_DIEGO_MLS;
        case 31338:
        case "PROVIDER_SAN_FRANCISCO_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_SAN_FRANCISCO_ASSOCIATION_OF_REALTORS;
        case 31339:
        case "PROVIDER_SAN_JUAN_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_SAN_JUAN_ASSOCIATION_OF_REALTORS;
        case 31340:
        case "PROVIDER_SANTA_BARBARA_MULTIPLE_LISTING_SERVICE":
            return Provider.PROVIDER_SANTA_BARBARA_MULTIPLE_LISTING_SERVICE;
        case 31341:
        case "PROVIDER_SANTA_FE_ASSOCIATION_OF_REALTORS_INC":
            return Provider.PROVIDER_SANTA_FE_ASSOCIATION_OF_REALTORS_INC;
        case 31342:
        case "PROVIDER_SAVANNAH_MULTILIST_CORPORATION":
            return Provider.PROVIDER_SAVANNAH_MULTILIST_CORPORATION;
        case 31343:
        case "PROVIDER_SCIOTO_VALLEY_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_SCIOTO_VALLEY_ASSOCIATION_OF_REALTORS;
        case 31344:
        case "PROVIDER_SEDONA_VERDE_VALLEY_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_SEDONA_VERDE_VALLEY_ASSOCIATION_OF_REALTORS;
        case 31345:
        case "PROVIDER_SHASTA_MLS":
            return Provider.PROVIDER_SHASTA_MLS;
        case 31346:
        case "PROVIDER_SMART_MLS":
            return Provider.PROVIDER_SMART_MLS;
        case 31347:
        case "PROVIDER_SNAKE_RIVER_REGIONAL_MLS":
            return Provider.PROVIDER_SNAKE_RIVER_REGIONAL_MLS;
        case 31348:
        case "PROVIDER_SOUTH_AFRICA":
            return Provider.PROVIDER_SOUTH_AFRICA;
        case 31349:
        case "PROVIDER_SOUTH_BROWARD_BOARD_OF_REALTORS":
            return Provider.PROVIDER_SOUTH_BROWARD_BOARD_OF_REALTORS;
        case 31350:
        case "PROVIDER_SOUTH_CENTRAL_ASSOCIATION_OF_REALTORS_MLS":
            return Provider.PROVIDER_SOUTH_CENTRAL_ASSOCIATION_OF_REALTORS_MLS;
        case 31351:
        case "PROVIDER_SOUTH_CENTRAL_KANSAS_MLS":
            return Provider.PROVIDER_SOUTH_CENTRAL_KANSAS_MLS;
        case 31352:
        case "PROVIDER_SOUTH_CENTRAL_WISCONSIN_MLS_CORPORATION":
            return Provider.PROVIDER_SOUTH_CENTRAL_WISCONSIN_MLS_CORPORATION;
        case 31353:
        case "PROVIDER_SOUTHEAST_ALASKA_MLS":
            return Provider.PROVIDER_SOUTHEAST_ALASKA_MLS;
        case 31354:
        case "PROVIDER_SOUTHEAST_KANSAS_MULTIPLE_LISTING_SYSTEM":
            return Provider.PROVIDER_SOUTHEAST_KANSAS_MULTIPLE_LISTING_SYSTEM;
        case 31355:
        case "PROVIDER_SOUTHERN_INDIANA_REALTOR_ASSOCIATION":
            return Provider.PROVIDER_SOUTHERN_INDIANA_REALTOR_ASSOCIATION;
        case 31356:
        case "PROVIDER_SOUTHERN_MISSOURI_REGIONAL_MLS_LLC":
            return Provider.PROVIDER_SOUTHERN_MISSOURI_REGIONAL_MLS_LLC;
        case 31357:
        case "PROVIDER_SOUTHERN_NEW_MEXICO_MLS":
            return Provider.PROVIDER_SOUTHERN_NEW_MEXICO_MLS;
        case 31358:
        case "PROVIDER_SOUTH_GEORGIA_MLS":
            return Provider.PROVIDER_SOUTH_GEORGIA_MLS;
        case 31359:
        case "PROVIDER_SOUTH_JERSEY_SHORE_REGIONAL_MLS":
            return Provider.PROVIDER_SOUTH_JERSEY_SHORE_REGIONAL_MLS;
        case 31360:
        case "PROVIDER_SOUTH_PADRE_ISLAND_BOARD_OF_REALTORS":
            return Provider.PROVIDER_SOUTH_PADRE_ISLAND_BOARD_OF_REALTORS;
        case 31361:
        case "PROVIDER_SOUTHWEST_MLS":
            return Provider.PROVIDER_SOUTHWEST_MLS;
        case 31362:
        case "PROVIDER_SOUTHWEST_VIRGINIA_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_SOUTHWEST_VIRGINIA_ASSOCIATION_OF_REALTORS;
        case 31363:
        case "PROVIDER_SPACE_COAST_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_SPACE_COAST_ASSOCIATION_OF_REALTORS;
        case 31364:
        case "PROVIDER_SPACE_COAST_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY":
            return Provider.PROVIDER_SPACE_COAST_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY;
        case 31365:
        case "PROVIDER_SPAIN":
            return Provider.PROVIDER_SPAIN;
        case 31366:
        case "PROVIDER_SPARTANBURG_ASSOCIATION_OF_REALTORS_INC":
            return Provider.PROVIDER_SPARTANBURG_ASSOCIATION_OF_REALTORS_INC;
        case 31367:
        case "PROVIDER_SPOKANE_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_SPOKANE_ASSOCIATION_OF_REALTORS;
        case 31368:
        case "PROVIDER_STATEN_ISLAND_BOARD_OF_REALTORS":
            return Provider.PROVIDER_STATEN_ISLAND_BOARD_OF_REALTORS;
        case 31369:
        case "PROVIDER_STATE_WIDE_MLS_OF_RHODE_ISLAND_INC":
            return Provider.PROVIDER_STATE_WIDE_MLS_OF_RHODE_ISLAND_INC;
        case 31370:
        case "PROVIDER_ST_AUGUSTINE_ST_JOHNS_COUNTY_BOARD_OF_REALTORS":
            return Provider.PROVIDER_ST_AUGUSTINE_ST_JOHNS_COUNTY_BOARD_OF_REALTORS;
        case 31371:
        case "PROVIDER_STILLWATER_BOARD_OF_REALTORS":
            return Provider.PROVIDER_STILLWATER_BOARD_OF_REALTORS;
        case 31372:
        case "PROVIDER_STRATEGIC_MLS_ALLIANCE":
            return Provider.PROVIDER_STRATEGIC_MLS_ALLIANCE;
        case 31373:
        case "PROVIDER_SUMMIT_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_SUMMIT_ASSOCIATION_OF_REALTORS;
        case 31374:
        case "PROVIDER_SUNFLOWER_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_SUNFLOWER_ASSOCIATION_OF_REALTORS;
        case 31375:
        case "PROVIDER_TAHOE_SIERRA_BOARD_OF_REALTORS":
            return Provider.PROVIDER_TAHOE_SIERRA_BOARD_OF_REALTORS;
        case 31376:
        case "PROVIDER_TAOS_COUNTY_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_TAOS_COUNTY_ASSOCIATION_OF_REALTORS;
        case 31377:
        case "PROVIDER_TENNESSEE_VIRGINIA_REGIONAL_MULTIPLE_LISTING_SERVICE":
            return Provider.PROVIDER_TENNESSEE_VIRGINIA_REGIONAL_MULTIPLE_LISTING_SERVICE;
        case 31378:
        case "PROVIDER_TETON_BOARD_OF_REALTORS":
            return Provider.PROVIDER_TETON_BOARD_OF_REALTORS;
        case 31379:
        case "PROVIDER_TEXARKANA_BOARD_OF_REALTORS":
            return Provider.PROVIDER_TEXARKANA_BOARD_OF_REALTORS;
        case 31380:
        case "PROVIDER_TILLAMOOK_COUNTY_BOARD_OF_REALTORS_MLS":
            return Provider.PROVIDER_TILLAMOOK_COUNTY_BOARD_OF_REALTORS_MLS;
        case 31381:
        case "PROVIDER_TOPSAIL_ISLAND_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_TOPSAIL_ISLAND_ASSOCIATION_OF_REALTORS;
        case 31382:
        case "PROVIDER_TRIAD_MULTIPLE_LISTING_SERVICE":
            return Provider.PROVIDER_TRIAD_MULTIPLE_LISTING_SERVICE;
        case 31383:
        case "PROVIDER_TRIANGLE_MLS":
            return Provider.PROVIDER_TRIANGLE_MLS;
        case 31384:
        case "PROVIDER_TRINITY_COUNTY_MLS":
            return Provider.PROVIDER_TRINITY_COUNTY_MLS;
        case 31385:
        case "PROVIDER_TULARE_COUNTY_MLS":
            return Provider.PROVIDER_TULARE_COUNTY_MLS;
        case 31386:
        case "PROVIDER_TUOLUMNE_COUNTY_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_TUOLUMNE_COUNTY_ASSOCIATION_OF_REALTORS;
        case 31387:
        case "PROVIDER_ULSTER_COUNTY_BOARD_OF_REALTORS_MLS":
            return Provider.PROVIDER_ULSTER_COUNTY_BOARD_OF_REALTORS_MLS;
        case 31388:
        case "PROVIDER_UPPER_CUMBERLAND_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_UPPER_CUMBERLAND_ASSOCIATION_OF_REALTORS;
        case 31389:
        case "PROVIDER_UPPER_PENINSULA_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_UPPER_PENINSULA_ASSOCIATION_OF_REALTORS;
        case 31390:
        case "PROVIDER_VAIL_BOARD_OF_REALTORS_MLS":
            return Provider.PROVIDER_VAIL_BOARD_OF_REALTORS_MLS;
        case 31391:
        case "PROVIDER_VALLEY_MLS":
            return Provider.PROVIDER_VALLEY_MLS;
        case 31392:
        case "PROVIDER_WACO_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_WACO_ASSOCIATION_OF_REALTORS;
        case 31393:
        case "PROVIDER_WASATCH_FRONT_REGIONAL_MLS":
            return Provider.PROVIDER_WASATCH_FRONT_REGIONAL_MLS;
        case 31394:
        case "PROVIDER_WASHINGTON_BEAUFORT_COUNTY_BOARD_OF_REALTORS":
            return Provider.PROVIDER_WASHINGTON_BEAUFORT_COUNTY_BOARD_OF_REALTORS;
        case 31395:
        case "PROVIDER_WASHINGTON_COUNTY_BOARD_OF_REALTORS":
            return Provider.PROVIDER_WASHINGTON_COUNTY_BOARD_OF_REALTORS;
        case 31396:
        case "PROVIDER_WEST_ALABAMA_MULTIPLE_LISTING_SERVICE":
            return Provider.PROVIDER_WEST_ALABAMA_MULTIPLE_LISTING_SERVICE;
        case 31397:
        case "PROVIDER_WEST_CENTRAL_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_WEST_CENTRAL_ASSOCIATION_OF_REALTORS;
        case 31398:
        case "PROVIDER_WESTCLIFFE_LISTING_SERVICE":
            return Provider.PROVIDER_WESTCLIFFE_LISTING_SERVICE;
        case 31399:
        case "PROVIDER_WESTERN_ARIZONA_REALTOR_DATA_EXCHANGE":
            return Provider.PROVIDER_WESTERN_ARIZONA_REALTOR_DATA_EXCHANGE;
        case 31400:
        case "PROVIDER_WESTERN_REGIONAL_INFORMATION_SYSTEMS_AND_TECHNOLOGY_INC":
            return Provider.PROVIDER_WESTERN_REGIONAL_INFORMATION_SYSTEMS_AND_TECHNOLOGY_INC;
        case 31401:
        case "PROVIDER_WESTERN_UPSTATE_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_WESTERN_UPSTATE_ASSOCIATION_OF_REALTORS;
        case 31402:
        case "PROVIDER_WEST_PENN_MULTI_LIST":
            return Provider.PROVIDER_WEST_PENN_MULTI_LIST;
        case 31403:
        case "PROVIDER_WHEELING_BOARD_OF_REALTORS":
            return Provider.PROVIDER_WHEELING_BOARD_OF_REALTORS;
        case 31404:
        case "PROVIDER_WHITE_MOUNTAIN_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_WHITE_MOUNTAIN_ASSOCIATION_OF_REALTORS;
        case 31405:
        case "PROVIDER_WILLAMETTE_VALLEY_MULTIPLE_LISTING_SERVICE":
            return Provider.PROVIDER_WILLAMETTE_VALLEY_MULTIPLE_LISTING_SERVICE;
        case 31406:
        case "PROVIDER_WILSON_BOARD_OF_REALTORS":
            return Provider.PROVIDER_WILSON_BOARD_OF_REALTORS;
        case 31407:
        case "PROVIDER_WINNIPEG_REGIONAL_REAL_ESTATE_BOARD":
            return Provider.PROVIDER_WINNIPEG_REGIONAL_REAL_ESTATE_BOARD;
        case 31408:
        case "PROVIDER_WYOMING_MLS":
            return Provider.PROVIDER_WYOMING_MLS;
        case 31409:
        case "PROVIDER_YUMA_ASSOCIATION_OF_REALTORS":
            return Provider.PROVIDER_YUMA_ASSOCIATION_OF_REALTORS;
        case 31412:
        case "PROVIDER_NORTH_CAROLINA_REGIONAL_MULTIPLE_LISTING_SERVICE":
            return Provider.PROVIDER_NORTH_CAROLINA_REGIONAL_MULTIPLE_LISTING_SERVICE;
        case 90000:
        case "PROVIDER_AGENT_UPLOAD":
            return Provider.PROVIDER_AGENT_UPLOAD;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Provider.UNRECOGNIZED;
    }
}
function providerToJSON(object) {
    switch (object) {
        case Provider.PROVIDER_UNSPECIFIED:
            return "PROVIDER_UNSPECIFIED";
        case Provider.PROVIDER_VREB_IDX:
            return "PROVIDER_VREB_IDX";
        case Provider.PROVIDER_LDON_IDX:
            return "PROVIDER_LDON_IDX";
        case Provider.PROVIDER_NSAR_IDX:
            return "PROVIDER_NSAR_IDX";
        case Provider.PROVIDER_NSAR_VOW:
            return "PROVIDER_NSAR_VOW";
        case Provider.PROVIDER_ALB_IDX:
            return "PROVIDER_ALB_IDX";
        case Provider.PROVIDER_CREB_IDX:
            return "PROVIDER_CREB_IDX";
        case Provider.PROVIDER_BRC_IDX:
            return "PROVIDER_BRC_IDX";
        case Provider.PROVIDER_TREB_VOW:
            return "PROVIDER_TREB_VOW";
        case Provider.PROVIDER_TREB_IDX:
            return "PROVIDER_TREB_IDX";
        case Provider.PROVIDER_RAHB_IDX:
            return "PROVIDER_RAHB_IDX";
        case Provider.PROVIDER_ITSO_IDX:
            return "PROVIDER_ITSO_IDX";
        case Provider.PROVIDER_OREB_VOW:
            return "PROVIDER_OREB_VOW";
        case Provider.PROVIDER_CREA_DDF:
            return "PROVIDER_CREA_DDF";
        case Provider.PROVIDER_ITSO_VOW:
            return "PROVIDER_ITSO_VOW";
        case Provider.PROVIDER_PILLAR9_IDX:
            return "PROVIDER_PILLAR9_IDX";
        case Provider.PROVIDER_PILLAR9_VOW:
            return "PROVIDER_PILLAR9_VOW";
        case Provider.PROVIDER_REBGV_IDX:
            return "PROVIDER_REBGV_IDX";
        case Provider.PROVIDER_REBGV_VOW:
            return "PROVIDER_REBGV_VOW";
        case Provider.PROVIDER_STELLAR_MLS_IDX:
            return "PROVIDER_STELLAR_MLS_IDX";
        case Provider.PROVIDER_MIAMI_SEF_IDX_PLUS:
            return "PROVIDER_MIAMI_SEF_IDX_PLUS";
        case Provider.PROVIDER_BRIGHT_MLS:
            return "PROVIDER_BRIGHT_MLS";
        case Provider.PROVIDER_ABERDEEN_BOARD_OF_REALTORS:
            return "PROVIDER_ABERDEEN_BOARD_OF_REALTORS";
        case Provider.PROVIDER_ADIRONDACK_CHAMPLAIN_VALLEY_MLS:
            return "PROVIDER_ADIRONDACK_CHAMPLAIN_VALLEY_MLS";
        case Provider.PROVIDER_AIKEN_MLS:
            return "PROVIDER_AIKEN_MLS";
        case Provider.PROVIDER_ALAMANCE_MULTIPLE_LISTING_SERVICE:
            return "PROVIDER_ALAMANCE_MULTIPLE_LISTING_SERVICE";
        case Provider.PROVIDER_ALASKA_MULTIPLE_LISTING_SERVICE:
            return "PROVIDER_ALASKA_MULTIPLE_LISTING_SERVICE";
        case Provider.PROVIDER_ALLEGHENY_HIGHLAND_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_ALLEGHENY_HIGHLAND_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_AMELIA_ISLANDUNDEFINED_NASSAU_COUNTY_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_AMELIA_ISLANDUNDEFINED_NASSAU_COUNTY_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_ARIZONA_REGIONAL_MULTIPLE_LISTING_SERVICE:
            return "PROVIDER_ARIZONA_REGIONAL_MULTIPLE_LISTING_SERVICE";
        case Provider.PROVIDER_ARIZONA_REGIONAL_MULTIPLE_LISTING_SERVICE_EXP_PORTAL_ONLY:
            return "PROVIDER_ARIZONA_REGIONAL_MULTIPLE_LISTING_SERVICE_EXP_PORTAL_ONLY";
        case Provider.PROVIDER_ASHLAND_AREA_BOARD_OF_REALTORS:
            return "PROVIDER_ASHLAND_AREA_BOARD_OF_REALTORS";
        case Provider.PROVIDER_ASHLAND_BOARD_OF_REALTORS:
            return "PROVIDER_ASHLAND_BOARD_OF_REALTORS";
        case Provider.PROVIDER_ASPEN_GLENWOOD_MLS:
            return "PROVIDER_ASPEN_GLENWOOD_MLS";
        case Provider.PROVIDER_ASSOCIATED_MULTILIST_SERVICES_OF_OKLAHOMA:
            return "PROVIDER_ASSOCIATED_MULTILIST_SERVICES_OF_OKLAHOMA";
        case Provider.PROVIDER_ATHENS_AREA_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_ATHENS_AREA_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_ATHENS_COUNTY_BOARD_OF_REALTORS:
            return "PROVIDER_ATHENS_COUNTY_BOARD_OF_REALTORS";
        case Provider.PROVIDER_AUSTIN_CENTRAL_TEXAS_REALTY_INFORMATION_SERVICE:
            return "PROVIDER_AUSTIN_CENTRAL_TEXAS_REALTY_INFORMATION_SERVICE";
        case Provider.PROVIDER_BADLANDS_BOARD_OF_REALTORS_INC_MLS:
            return "PROVIDER_BADLANDS_BOARD_OF_REALTORS_INC_MLS";
        case Provider.PROVIDER_BAKERSFIELD_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_BAKERSFIELD_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_BALDWIN_REALTORS:
            return "PROVIDER_BALDWIN_REALTORS";
        case Provider.PROVIDER_BAY_AREA_REAL_ESTATE_INFORMATION_SERVICES_INC:
            return "PROVIDER_BAY_AREA_REAL_ESTATE_INFORMATION_SERVICES_INC";
        case Provider.PROVIDER_BEACHES_MLS:
            return "PROVIDER_BEACHES_MLS";
        case Provider.PROVIDER_BEACHES_MLS_EXP_PORTAL_ONLY:
            return "PROVIDER_BEACHES_MLS_EXP_PORTAL_ONLY";
        case Provider.PROVIDER_BEAUMONT_BOARD_OF_REALTORS_INC_MLS:
            return "PROVIDER_BEAUMONT_BOARD_OF_REALTORS_INC_MLS";
        case Provider.PROVIDER_BERKSHIRE_COUNTY_BOARD_OF_REALTORS:
            return "PROVIDER_BERKSHIRE_COUNTY_BOARD_OF_REALTORS";
        case Provider.PROVIDER_BIG_SKY_COUNTRY_MLS:
            return "PROVIDER_BIG_SKY_COUNTRY_MLS";
        case Provider.PROVIDER_BILLINGS_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_BILLINGS_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_BILLINGS_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY:
            return "PROVIDER_BILLINGS_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY";
        case Provider.PROVIDER_BISMARCK_MANDAN_BOARD_OF_REALTORS:
            return "PROVIDER_BISMARCK_MANDAN_BOARD_OF_REALTORS";
        case Provider.PROVIDER_BLACK_HILLS_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_BLACK_HILLS_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_BLUEGRASS_REALTORS:
            return "PROVIDER_BLUEGRASS_REALTORS";
        case Provider.PROVIDER_BONITA_SPRINGS_ESTERO_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_BONITA_SPRINGS_ESTERO_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_BRASIL:
            return "PROVIDER_BRASIL";
        case Provider.PROVIDER_BRAZORIA_COUNTY_BOARD_OF_REALTORS:
            return "PROVIDER_BRAZORIA_COUNTY_BOARD_OF_REALTORS";
        case Provider.PROVIDER_BROOKLYN_NEW_YORK_MLS:
            return "PROVIDER_BROOKLYN_NEW_YORK_MLS";
        case Provider.PROVIDER_BRUNSWICK_COUNTY_MLS:
            return "PROVIDER_BRUNSWICK_COUNTY_MLS";
        case Provider.PROVIDER_BRYANCOLLEGE_STATION_REGIONAL_MLS:
            return "PROVIDER_BRYANCOLLEGE_STATION_REGIONAL_MLS";
        case Provider.PROVIDER_CALAVERAS_COUNTY_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_CALAVERAS_COUNTY_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_CALIFORNIA_REGIONAL_MULTIPLE_LISTING_SERVICE:
            return "PROVIDER_CALIFORNIA_REGIONAL_MULTIPLE_LISTING_SERVICE";
        case Provider.PROVIDER_CAMBRIA_SOMERSET_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_CAMBRIA_SOMERSET_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_CANOPY_MLS:
            return "PROVIDER_CANOPY_MLS";
        case Provider.PROVIDER_CAPE_CODUNDEFINED_ISLANDS_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_CAPE_CODUNDEFINED_ISLANDS_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_CAPE_FEAR_REALTORS:
            return "PROVIDER_CAPE_FEAR_REALTORS";
        case Provider.PROVIDER_CAPE_MAY_COUNTY_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_CAPE_MAY_COUNTY_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_CAPITAL_AREA_TECHNOLOGY_REALTOR_SERVICES:
            return "PROVIDER_CAPITAL_AREA_TECHNOLOGY_REALTOR_SERVICES";
        case Provider.PROVIDER_CARPET_CAPITAL_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_CARPET_CAPITAL_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_CARPET_CAPITAL_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY:
            return "PROVIDER_CARPET_CAPITAL_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY";
        case Provider.PROVIDER_CARTERET_COUNTY_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_CARTERET_COUNTY_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_CEDAR_RAPIDS_AREA_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_CEDAR_RAPIDS_AREA_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_CENTRAL_GEORGIA_MLS:
            return "PROVIDER_CENTRAL_GEORGIA_MLS";
        case Provider.PROVIDER_CENTRAL_GEORGIA_MLS_EXP_PORTAL_ONLY:
            return "PROVIDER_CENTRAL_GEORGIA_MLS_EXP_PORTAL_ONLY";
        case Provider.PROVIDER_CENTRAL_HILL_COUNTRY_BOARD_OF_REALTORS:
            return "PROVIDER_CENTRAL_HILL_COUNTRY_BOARD_OF_REALTORS";
        case Provider.PROVIDER_CENTRAL_ILLINOIS_BOARD_OF_REALTORS:
            return "PROVIDER_CENTRAL_ILLINOIS_BOARD_OF_REALTORS";
        case Provider.PROVIDER_CENTRAL_JERSEY_MULTIPLE_LISTING_SYSTEM_INC:
            return "PROVIDER_CENTRAL_JERSEY_MULTIPLE_LISTING_SYSTEM_INC";
        case Provider.PROVIDER_CENTRAL_MISSISSIPPI_MLS:
            return "PROVIDER_CENTRAL_MISSISSIPPI_MLS";
        case Provider.PROVIDER_CENTRAL_PANHANDLE_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_CENTRAL_PANHANDLE_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_CENTRAL_SUSQUEHANNA_VALLEY_BOARD_OF_REALTORS:
            return "PROVIDER_CENTRAL_SUSQUEHANNA_VALLEY_BOARD_OF_REALTORS";
        case Provider.PROVIDER_CENTRAL_TEXAS_MULTIPLE_LISTING_SERVICE:
            return "PROVIDER_CENTRAL_TEXAS_MULTIPLE_LISTING_SERVICE";
        case Provider.PROVIDER_CENTRAL_VIRGINIA_REGIONAL_MULTIPLE_LISTING_SERVICE:
            return "PROVIDER_CENTRAL_VIRGINIA_REGIONAL_MULTIPLE_LISTING_SERVICE";
        case Provider.PROVIDER_CENTRAL_WEST_TENNESSEE_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_CENTRAL_WEST_TENNESSEE_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_CENTRAL_WISCONSIN_MLS:
            return "PROVIDER_CENTRAL_WISCONSIN_MLS";
        case Provider.PROVIDER_CHARLOTTESVILLE_AREA_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_CHARLOTTESVILLE_AREA_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_CHS_REGIONAL_MLS:
            return "PROVIDER_CHS_REGIONAL_MLS";
        case Provider.PROVIDER_CLATSOP_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_CLATSOP_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_CLEARFIELDJEFFERSON_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_CLEARFIELDJEFFERSON_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_COASTAL_CAROLINA_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_COASTAL_CAROLINA_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_COEUR_DALENE_MULTIPLE_LISTING_SERVICE:
            return "PROVIDER_COEUR_DALENE_MULTIPLE_LISTING_SERVICE";
        case Provider.PROVIDER_COLORADO_REAL_ESTATE_NETWORK_INC:
            return "PROVIDER_COLORADO_REAL_ESTATE_NETWORK_INC";
        case Provider.PROVIDER_COLUMBIA:
            return "PROVIDER_COLUMBIA";
        case Provider.PROVIDER_COLUMBIA_BOARD_OF_REALTORS:
            return "PROVIDER_COLUMBIA_BOARD_OF_REALTORS";
        case Provider.PROVIDER_COLUMBIA_GREENE_AND_NORTHERN_DUTCHESS_MLS:
            return "PROVIDER_COLUMBIA_GREENE_AND_NORTHERN_DUTCHESS_MLS";
        case Provider.PROVIDER_COLUMBUS_AND_CENTRAL_OHIO_MULTIPLE_LISTING_SERVICE:
            return "PROVIDER_COLUMBUS_AND_CENTRAL_OHIO_MULTIPLE_LISTING_SERVICE";
        case Provider.PROVIDER_COLUMBUS_BOARD_OF_REALTORS:
            return "PROVIDER_COLUMBUS_BOARD_OF_REALTORS";
        case Provider.PROVIDER_CONSOLIDATED_MLS_INC:
            return "PROVIDER_CONSOLIDATED_MLS_INC";
        case Provider.PROVIDER_CONTRA_COSTA_AOR_BAY_EAST_AOR_AND_BRIDGE_MLS:
            return "PROVIDER_CONTRA_COSTA_AOR_BAY_EAST_AOR_AND_BRIDGE_MLS";
        case Provider.PROVIDER_COOPERATIVE_ARKANSAS_REALTORS_MULTIPLE_LISTING_SERVICE:
            return "PROVIDER_COOPERATIVE_ARKANSAS_REALTORS_MULTIPLE_LISTING_SERVICE";
        case Provider.PROVIDER_CORPUS_CHRISTI_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_CORPUS_CHRISTI_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_CREA:
            return "PROVIDER_CREA";
        case Provider.PROVIDER_DAYTONA_BEACH_AREA_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_DAYTONA_BEACH_AREA_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_DAYTON_REALTORS_MLS:
            return "PROVIDER_DAYTON_REALTORS_MLS";
        case Provider.PROVIDER_DEMO_MLS:
            return "PROVIDER_DEMO_MLS";
        case Provider.PROVIDER_DES_MOINES_AREA_ASSOCIATION_OF_REALTORS_INC:
            return "PROVIDER_DES_MOINES_AREA_ASSOCIATION_OF_REALTORS_INC";
        case Provider.PROVIDER_DIXIE_GILCHRIST_LEVY_COUNTIES_BOARD_OF_REALTORS:
            return "PROVIDER_DIXIE_GILCHRIST_LEVY_COUNTIES_BOARD_OF_REALTORS";
        case Provider.PROVIDER_DOMINICAN_REPUBLIC:
            return "PROVIDER_DOMINICAN_REPUBLIC";
        case Provider.PROVIDER_DUBLIN_BOARD_OF_REALTORS:
            return "PROVIDER_DUBLIN_BOARD_OF_REALTORS";
        case Provider.PROVIDER_DUMMY_MLS_FOR_QA:
            return "PROVIDER_DUMMY_MLS_FOR_QA";
        case Provider.PROVIDER_ELKO_COUNTY_BOARD_OF_REALTORS:
            return "PROVIDER_ELKO_COUNTY_BOARD_OF_REALTORS";
        case Provider.PROVIDER_ELMIRACORNING_REGIONAL_BOARD_OF_REALTORS_MLS:
            return "PROVIDER_ELMIRACORNING_REGIONAL_BOARD_OF_REALTORS_MLS";
        case Provider.PROVIDER_EMERALD_COAST_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_EMERALD_COAST_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_EMERALD_COAST_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY:
            return "PROVIDER_EMERALD_COAST_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY";
        case Provider.PROVIDER_EXP_PORTAL1:
            return "PROVIDER_EXP_PORTAL1";
        case Provider.PROVIDER_EXP_PORTAL10:
            return "PROVIDER_EXP_PORTAL10";
        case Provider.PROVIDER_EXP_PORTAL11:
            return "PROVIDER_EXP_PORTAL11";
        case Provider.PROVIDER_EXP_PORTAL12:
            return "PROVIDER_EXP_PORTAL12";
        case Provider.PROVIDER_EXP_PORTAL13:
            return "PROVIDER_EXP_PORTAL13";
        case Provider.PROVIDER_EXP_PORTAL14:
            return "PROVIDER_EXP_PORTAL14";
        case Provider.PROVIDER_EXP_PORTAL15:
            return "PROVIDER_EXP_PORTAL15";
        case Provider.PROVIDER_EXP_PORTAL18:
            return "PROVIDER_EXP_PORTAL18";
        case Provider.PROVIDER_EXP_PORTAL19:
            return "PROVIDER_EXP_PORTAL19";
        case Provider.PROVIDER_EXP_PORTAL2:
            return "PROVIDER_EXP_PORTAL2";
        case Provider.PROVIDER_EXP_PORTAL20:
            return "PROVIDER_EXP_PORTAL20";
        case Provider.PROVIDER_EXP_PORTAL21:
            return "PROVIDER_EXP_PORTAL21";
        case Provider.PROVIDER_EXP_PORTAL22:
            return "PROVIDER_EXP_PORTAL22";
        case Provider.PROVIDER_EXP_PORTAL23:
            return "PROVIDER_EXP_PORTAL23";
        case Provider.PROVIDER_EXP_PORTAL24_SMART:
            return "PROVIDER_EXP_PORTAL24_SMART";
        case Provider.PROVIDER_EXP_PORTAL24_CR_MLS:
            return "PROVIDER_EXP_PORTAL24_CR_MLS";
        case Provider.PROVIDER_EXP_PORTAL3:
            return "PROVIDER_EXP_PORTAL3";
        case Provider.PROVIDER_EXP_PORTAL4:
            return "PROVIDER_EXP_PORTAL4";
        case Provider.PROVIDER_EXP_PORTAL5:
            return "PROVIDER_EXP_PORTAL5";
        case Provider.PROVIDER_EXP_PORTAL6:
            return "PROVIDER_EXP_PORTAL6";
        case Provider.PROVIDER_EXP_PORTAL7:
            return "PROVIDER_EXP_PORTAL7";
        case Provider.PROVIDER_EXP_PORTAL8:
            return "PROVIDER_EXP_PORTAL8";
        case Provider.PROVIDER_EXP_PORTAL9:
            return "PROVIDER_EXP_PORTAL9";
        case Provider.PROVIDER_FARGO_MOORHEAD_AREA_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_FARGO_MOORHEAD_AREA_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_FIRELANDS_MLS:
            return "PROVIDER_FIRELANDS_MLS";
        case Provider.PROVIDER_FIRST_MULTIPLE_LISTING_SERVICE:
            return "PROVIDER_FIRST_MULTIPLE_LISTING_SERVICE";
        case Provider.PROVIDER_FLINT_HILLS_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_FLINT_HILLS_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_FLORIDA_KEYS_BOARD_OF_REALTORS:
            return "PROVIDER_FLORIDA_KEYS_BOARD_OF_REALTORS";
        case Provider.PROVIDER_FORT_DODGE_MLS:
            return "PROVIDER_FORT_DODGE_MLS";
        case Provider.PROVIDER_FRANCE:
            return "PROVIDER_FRANCE";
        case Provider.PROVIDER_FRESNO_MLS:
            return "PROVIDER_FRESNO_MLS";
        case Provider.PROVIDER_GALVESTON_ASSOCIATION_OF_REALTORS_MLS:
            return "PROVIDER_GALVESTON_ASSOCIATION_OF_REALTORS_MLS";
        case Provider.PROVIDER_GARDEN_STATE_MLS:
            return "PROVIDER_GARDEN_STATE_MLS";
        case Provider.PROVIDER_GARDEN_STATE_MLS_EXP_PORTAL_ONLY:
            return "PROVIDER_GARDEN_STATE_MLS_EXP_PORTAL_ONLY";
        case Provider.PROVIDER_GEORGIA_MULTIPLE_LISTING_SERVICE:
            return "PROVIDER_GEORGIA_MULTIPLE_LISTING_SERVICE";
        case Provider.PROVIDER_GERMANY:
            return "PROVIDER_GERMANY";
        case Provider.PROVIDER_GLOBAL_MLS_INC:
            return "PROVIDER_GLOBAL_MLS_INC";
        case Provider.PROVIDER_GOLDSBORO_WAYNE_COUNTY_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_GOLDSBORO_WAYNE_COUNTY_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_GRAND_COUNTY_BOARD_OF_REALTORS:
            return "PROVIDER_GRAND_COUNTY_BOARD_OF_REALTORS";
        case Provider.PROVIDER_GRAND_ISLAND_BOARD_OF_REALTORS:
            return "PROVIDER_GRAND_ISLAND_BOARD_OF_REALTORS";
        case Provider.PROVIDER_GRAND_JUNCTION_AREA_REALTORS_ASSOCIATION_MLS:
            return "PROVIDER_GRAND_JUNCTION_AREA_REALTORS_ASSOCIATION_MLS";
        case Provider.PROVIDER_GREATER_ALABAMA_MLS:
            return "PROVIDER_GREATER_ALABAMA_MLS";
        case Provider.PROVIDER_GREATER_ANTELOPE_VALLEY_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_GREATER_ANTELOPE_VALLEY_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_GREATER_AUGUSTA_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_GREATER_AUGUSTA_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_GREATER_BATON_ROUGE_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_GREATER_BATON_ROUGE_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_GREATER_CHATTANOOGA_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_GREATER_CHATTANOOGA_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_GREATER_CHATTANOOGA_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY:
            return "PROVIDER_GREATER_CHATTANOOGA_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY";
        case Provider.PROVIDER_GREATER_EL_PASO_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_GREATER_EL_PASO_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_GREATER_ERIE_BOARD_OF_REALTORS_MLS:
            return "PROVIDER_GREATER_ERIE_BOARD_OF_REALTORS_MLS";
        case Provider.PROVIDER_GREATER_GREENVILLE_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_GREATER_GREENVILLE_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_GREATER_LAS_VEGAS_ASSOCIATION_OF_REALTORS_INC:
            return "PROVIDER_GREATER_LAS_VEGAS_ASSOCIATION_OF_REALTORS_INC";
        case Provider.PROVIDER_GREATER_LEHIGH_VALLEY_REALTORS:
            return "PROVIDER_GREATER_LEHIGH_VALLEY_REALTORS";
        case Provider.PROVIDER_GREATER_LOUISVILLE_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_GREATER_LOUISVILLE_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_GREATER_MASON_CITY_BOARD_OF_REALTORS:
            return "PROVIDER_GREATER_MASON_CITY_BOARD_OF_REALTORS";
        case Provider.PROVIDER_GREATER_MCALLEN_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_GREATER_MCALLEN_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_GREATER_REGIONAL_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_GREATER_REGIONAL_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_GREATER_NORTHWEST_INDIANA_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_GREATER_NORTHWEST_INDIANA_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_GREATER_OWENSBORO_REALTOR_ASSOCIATION:
            return "PROVIDER_GREATER_OWENSBORO_REALTOR_ASSOCIATION";
        case Provider.PROVIDER_GREATER_PORTSMOUTH_AREA_MULTIPLE_LISTING_SERVICE:
            return "PROVIDER_GREATER_PORTSMOUTH_AREA_MULTIPLE_LISTING_SERVICE";
        case Provider.PROVIDER_GREATER_SOUTHERN_MLS:
            return "PROVIDER_GREATER_SOUTHERN_MLS";
        case Provider.PROVIDER_GREATER_TYLER_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_GREATER_TYLER_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_GREATER_TYLER_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY:
            return "PROVIDER_GREATER_TYLER_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY";
        case Provider.PROVIDER_GREAT_PLAINS_REGIONAL_MLS:
            return "PROVIDER_GREAT_PLAINS_REGIONAL_MLS";
        case Provider.PROVIDER_GREAT_SMOKY_MOUNTAINS_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_GREAT_SMOKY_MOUNTAINS_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_GREECE:
            return "PROVIDER_GREECE";
        case Provider.PROVIDER_GREENVILLEPITT_ASSOCIATION_OF_REALTORS_MLS:
            return "PROVIDER_GREENVILLEPITT_ASSOCIATION_OF_REALTORS_MLS";
        case Provider.PROVIDER_GREENWICH_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_GREENWICH_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_GULF_COAST_MULTIPLE_LISTING_SERVICE:
            return "PROVIDER_GULF_COAST_MULTIPLE_LISTING_SERVICE";
        case Provider.PROVIDER_GULF_SOUTH_REAL_ESTATE_INFORMATION_NETWORK:
            return "PROVIDER_GULF_SOUTH_REAL_ESTATE_INFORMATION_NETWORK";
        case Provider.PROVIDER_HATTIESBURG_AREA_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_HATTIESBURG_AREA_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_HAWAII_INFORMATION_SERVICE:
            return "PROVIDER_HAWAII_INFORMATION_SERVICE";
        case Provider.PROVIDER_HEARTLAND_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_HEARTLAND_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_HEARTLAND_MLS:
            return "PROVIDER_HEARTLAND_MLS";
        case Provider.PROVIDER_HEART_OF_KENTUCKY_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_HEART_OF_KENTUCKY_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_HERNANDO_COUNTY_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_HERNANDO_COUNTY_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_HIGH_COUNTRY_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_HIGH_COUNTRY_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_HIGHLAND_LAKES_ASSOCIATION_OF_REALTORS_MLS:
            return "PROVIDER_HIGHLAND_LAKES_ASSOCIATION_OF_REALTORS_MLS";
        case Provider.PROVIDER_HIGHLANDS_CASHIERS_BOARD_OF_REALTORS:
            return "PROVIDER_HIGHLANDS_CASHIERS_BOARD_OF_REALTORS";
        case Provider.PROVIDER_HINESVILLE_AREA_BOARD_OF_REALTORS_INC_MLS:
            return "PROVIDER_HINESVILLE_AREA_BOARD_OF_REALTORS_INC_MLS";
        case Provider.PROVIDER_HONOLULU_BOARD_OF_REALTORS:
            return "PROVIDER_HONOLULU_BOARD_OF_REALTORS";
        case Provider.PROVIDER_HONOLULU_BOARD_OF_REALTORS_EXP:
            return "PROVIDER_HONOLULU_BOARD_OF_REALTORS_EXP";
        case Provider.PROVIDER_HOPKINSVILLE_CHRISTIAN_COUNTY_BOARD_OF_REALTORS:
            return "PROVIDER_HOPKINSVILLE_CHRISTIAN_COUNTY_BOARD_OF_REALTORS";
        case Provider.PROVIDER_HOT_SPRINGS_BOARD_OF_REALTORS:
            return "PROVIDER_HOT_SPRINGS_BOARD_OF_REALTORS";
        case Provider.PROVIDER_HOUSTON_REALTORS_INFORMATION_SERVICE:
            return "PROVIDER_HOUSTON_REALTORS_INFORMATION_SERVICE";
        case Provider.PROVIDER_HUDSON_COUNTY_MULTIPLE_LISTING_SERVICE:
            return "PROVIDER_HUDSON_COUNTY_MULTIPLE_LISTING_SERVICE";
        case Provider.PROVIDER_HUMBOLDT_COUNTY_MLS:
            return "PROVIDER_HUMBOLDT_COUNTY_MLS";
        case Provider.PROVIDER_INCLINE_VILLAGE_BOARD_OF_REALTORS:
            return "PROVIDER_INCLINE_VILLAGE_BOARD_OF_REALTORS";
        case Provider.PROVIDER_INDIA:
            return "PROVIDER_INDIA";
        case Provider.PROVIDER_INDIANA_REGIONAL_MLS:
            return "PROVIDER_INDIANA_REGIONAL_MLS";
        case Provider.PROVIDER_INFORMATION_AND_REAL_ESTATE_SERVICES:
            return "PROVIDER_INFORMATION_AND_REAL_ESTATE_SERVICES";
        case Provider.PROVIDER_INTERMOUNTAIN_MULTIPLE_LISTING_SERVICE:
            return "PROVIDER_INTERMOUNTAIN_MULTIPLE_LISTING_SERVICE";
        case Provider.PROVIDER_IOWA_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_IOWA_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_IOWA_GREAT_LAKES_BOARD_OF_REALTORS:
            return "PROVIDER_IOWA_GREAT_LAKES_BOARD_OF_REALTORS";
        case Provider.PROVIDER_ISRAEL:
            return "PROVIDER_ISRAEL";
        case Provider.PROVIDER_ITALY:
            return "PROVIDER_ITALY";
        case Provider.PROVIDER_JACKSONVILLE_BOARD_OF_REALTORS_NC:
            return "PROVIDER_JACKSONVILLE_BOARD_OF_REALTORS_NC";
        case Provider.PROVIDER_JEFFERSON_CITY_AREA_BOARD_OF_REALTORS:
            return "PROVIDER_JEFFERSON_CITY_AREA_BOARD_OF_REALTORS";
        case Provider.PROVIDER_KANAB_UT_MLS:
            return "PROVIDER_KANAB_UT_MLS";
        case Provider.PROVIDER_KANAWHA_VALLEY_BOARD_OF_REALTORS:
            return "PROVIDER_KANAWHA_VALLEY_BOARD_OF_REALTORS";
        case Provider.PROVIDER_KEY_WEST_ASSOCIATION_OF_REALTORS_MLS:
            return "PROVIDER_KEY_WEST_ASSOCIATION_OF_REALTORS_MLS";
        case Provider.PROVIDER_KNOXVILLE_AREA_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_KNOXVILLE_AREA_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_LAKE_COUNTRY_BOARD_OF_REALTORS:
            return "PROVIDER_LAKE_COUNTRY_BOARD_OF_REALTORS";
        case Provider.PROVIDER_LAKE_HAVASU_ASSOCIATION_MLS:
            return "PROVIDER_LAKE_HAVASU_ASSOCIATION_MLS";
        case Provider.PROVIDER_LAKE_SUPERIOR_AREA_REALTORS:
            return "PROVIDER_LAKE_SUPERIOR_AREA_REALTORS";
        case Provider.PROVIDER_LAKEWAY_AREA_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_LAKEWAY_AREA_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_LAWRENCE_BOARD_OF_REALTORS:
            return "PROVIDER_LAWRENCE_BOARD_OF_REALTORS";
        case Provider.PROVIDER_LEE_COUNTY_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_LEE_COUNTY_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_LINCOLN_COUNTY_BOARD_OF_REALTORS:
            return "PROVIDER_LINCOLN_COUNTY_BOARD_OF_REALTORS";
        case Provider.PROVIDER_LONGLEAF_PINE_REALTORS:
            return "PROVIDER_LONGLEAF_PINE_REALTORS";
        case Provider.PROVIDER_LONGVIEW_AREA_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_LONGVIEW_AREA_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_LOWCOUNTRY_REGIONAL_MULTIPLE_LISTING_SERVICE_INC:
            return "PROVIDER_LOWCOUNTRY_REGIONAL_MULTIPLE_LISTING_SERVICE_INC";
        case Provider.PROVIDER_LUBBOCK_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_LUBBOCK_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_LYNCHBURG_VIRGINIA_MLS:
            return "PROVIDER_LYNCHBURG_VIRGINIA_MLS";
        case Provider.PROVIDER_MAINE_REAL_ESTATE_INFORMATION_SYSTEM_INC:
            return "PROVIDER_MAINE_REAL_ESTATE_INFORMATION_SYSTEM_INC";
        case Provider.PROVIDER_MANSFIELD_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_MANSFIELD_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_MARCO_ISLAND_AREA_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_MARCO_ISLAND_AREA_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_MARTHAS_VINEYARD_MLS:
            return "PROVIDER_MARTHAS_VINEYARD_MLS";
        case Provider.PROVIDER_MARTIN_COUNTY_REALTORS_OF_THE_TREASURE_COAST:
            return "PROVIDER_MARTIN_COUNTY_REALTORS_OF_THE_TREASURE_COAST";
        case Provider.PROVIDER_MEMPHIS_AREA_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_MEMPHIS_AREA_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_MERCER_TAZEWELL_CO_BOR:
            return "PROVIDER_MERCER_TAZEWELL_CO_BOR";
        case Provider.PROVIDER_METROLIST_CA:
            return "PROVIDER_METROLIST_CA";
        case Provider.PROVIDER_METRO_MLS:
            return "PROVIDER_METRO_MLS";
        case Provider.PROVIDER_MEXICO:
            return "PROVIDER_MEXICO";
        case Provider.PROVIDER_MIBOR_SERVICE_CORPORATION:
            return "PROVIDER_MIBOR_SERVICE_CORPORATION";
        case Provider.PROVIDER_MICHIGAN_REGIONAL_INFORMATION_CENTER:
            return "PROVIDER_MICHIGAN_REGIONAL_INFORMATION_CENTER";
        case Provider.PROVIDER_MID_AMERICA_REGIONAL_INFORMATION_SYSTEMS:
            return "PROVIDER_MID_AMERICA_REGIONAL_INFORMATION_SYSTEMS";
        case Provider.PROVIDER_MIDDLE_GEORGIA_MLS:
            return "PROVIDER_MIDDLE_GEORGIA_MLS";
        case Provider.PROVIDER_MIDDLE_TENNESSEE_REGIONAL_MLS:
            return "PROVIDER_MIDDLE_TENNESSEE_REGIONAL_MLS";
        case Provider.PROVIDER_MIDHUDSON_MULTIPLE_LISTING_SERVICE:
            return "PROVIDER_MIDHUDSON_MULTIPLE_LISTING_SERVICE";
        case Provider.PROVIDER_MIDWEST_REAL_ESTATE_DATA:
            return "PROVIDER_MIDWEST_REAL_ESTATE_DATA";
        case Provider.PROVIDER_MILLEDGEVILLE_MLS:
            return "PROVIDER_MILLEDGEVILLE_MLS";
        case Provider.PROVIDER_MLS_LISTINGS_INC:
            return "PROVIDER_MLS_LISTINGS_INC";
        case Provider.PROVIDER_MLS_NOW:
            return "PROVIDER_MLS_NOW";
        case Provider.PROVIDER_MLS_OF_CENTRAL_OREGON:
            return "PROVIDER_MLS_OF_CENTRAL_OREGON";
        case Provider.PROVIDER_MLS_OF_GREATER_CINCINNATI_INC:
            return "PROVIDER_MLS_OF_GREATER_CINCINNATI_INC";
        case Provider.PROVIDER_MLS_OF_YAKIMA_ASSOCIATION:
            return "PROVIDER_MLS_OF_YAKIMA_ASSOCIATION";
        case Provider.PROVIDER_MLS_PROPERTY_INFORMATION_NETWORK:
            return "PROVIDER_MLS_PROPERTY_INFORMATION_NETWORK";
        case Provider.PROVIDER_MLS_TECHNOLOGY:
            return "PROVIDER_MLS_TECHNOLOGY";
        case Provider.PROVIDER_MLS_UNITED:
            return "PROVIDER_MLS_UNITED";
        case Provider.PROVIDER_MONMOUTHOCEAN_MULTIPLE_LISTING_SERVICE:
            return "PROVIDER_MONMOUTHOCEAN_MULTIPLE_LISTING_SERVICE";
        case Provider.PROVIDER_MONTANA_REGIONAL_MLS:
            return "PROVIDER_MONTANA_REGIONAL_MLS";
        case Provider.PROVIDER_MONTGOMERY_AREA_ASSOCIATION_OF_REALTORS_MLS:
            return "PROVIDER_MONTGOMERY_AREA_ASSOCIATION_OF_REALTORS_MLS";
        case Provider.PROVIDER_MOUNTAIN_LAKES_BOARD_OF_REALTORS:
            return "PROVIDER_MOUNTAIN_LAKES_BOARD_OF_REALTORS";
        case Provider.PROVIDER_MT_RUSHMORE_AREA_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_MT_RUSHMORE_AREA_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_MULTIPLE_LISTING_SERVICE_MIREALSOURCE:
            return "PROVIDER_MULTIPLE_LISTING_SERVICE_MIREALSOURCE";
        case Provider.PROVIDER_MULTIPLE_LISTING_SERVICE_OF_HILTON_HEAD_ISLAND_INC:
            return "PROVIDER_MULTIPLE_LISTING_SERVICE_OF_HILTON_HEAD_ISLAND_INC";
        case Provider.PROVIDER_MULTIPLE_LISTING_SERVICE_OF_SOUTHERN_ARIZONA:
            return "PROVIDER_MULTIPLE_LISTING_SERVICE_OF_SOUTHERN_ARIZONA";
        case Provider.PROVIDER_NAPLES_AREA_BOARD_OF_REALTORS:
            return "PROVIDER_NAPLES_AREA_BOARD_OF_REALTORS";
        case Provider.PROVIDER_NEUSE_RIVER_REGION_MLS_INC:
            return "PROVIDER_NEUSE_RIVER_REGION_MLS_INC";
        case Provider.PROVIDER_NEW_CANAAN_BOARD_OF_REALTORS:
            return "PROVIDER_NEW_CANAAN_BOARD_OF_REALTORS";
        case Provider.PROVIDER_NEW_JERSEY_MLS:
            return "PROVIDER_NEW_JERSEY_MLS";
        case Provider.PROVIDER_NEW_SMYRNA_BEACH_BOARD_OF_REALTORS:
            return "PROVIDER_NEW_SMYRNA_BEACH_BOARD_OF_REALTORS";
        case Provider.PROVIDER_NEW_YORK_STATE_ALLIANCE_OF_MLSS:
            return "PROVIDER_NEW_YORK_STATE_ALLIANCE_OF_MLSS";
        case Provider.PROVIDER_NEW_ZEALAND:
            return "PROVIDER_NEW_ZEALAND";
        case Provider.PROVIDER_NORTH_CENTRAL_WEST_VIRGINIA_REAL_ESTATE_INFORMATION_NETWORK:
            return "PROVIDER_NORTH_CENTRAL_WEST_VIRGINIA_REAL_ESTATE_INFORMATION_NETWORK";
        case Provider.PROVIDER_NORTHEAST_ARKANSAS_BOARD_OF_REALTORS:
            return "PROVIDER_NORTHEAST_ARKANSAS_BOARD_OF_REALTORS";
        case Provider.PROVIDER_NORTHEAST_GEORGIA_BOARD_OF_REALTORS:
            return "PROVIDER_NORTHEAST_GEORGIA_BOARD_OF_REALTORS";
        case Provider.PROVIDER_NORTHEAST_IOWA_REGIONAL_BOARD_OF_REALTORS:
            return "PROVIDER_NORTHEAST_IOWA_REGIONAL_BOARD_OF_REALTORS";
        case Provider.PROVIDER_NORTHEAST_LOUISIANA_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_NORTHEAST_LOUISIANA_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_NORTHEAST_OKLAHOMA_BOARD_OF_REALTORS:
            return "PROVIDER_NORTHEAST_OKLAHOMA_BOARD_OF_REALTORS";
        case Provider.PROVIDER_NORTHERN_ARIZONA_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_NORTHERN_ARIZONA_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_NORTHERN_GREAT_LAKES_REALTORS_MLS:
            return "PROVIDER_NORTHERN_GREAT_LAKES_REALTORS_MLS";
        case Provider.PROVIDER_NORTHERN_KENTUCKY_MULTIPLE_LISTING_SERVICE:
            return "PROVIDER_NORTHERN_KENTUCKY_MULTIPLE_LISTING_SERVICE";
        case Provider.PROVIDER_NORTHERN_NEVADA_REGIONAL_MLS_INC:
            return "PROVIDER_NORTHERN_NEVADA_REGIONAL_MLS_INC";
        case Provider.PROVIDER_NORTH_FLORIDA_MLS:
            return "PROVIDER_NORTH_FLORIDA_MLS";
        case Provider.PROVIDER_NORTH_SANTA_BARBARA_COUNTY_REGIONAL_MLS:
            return "PROVIDER_NORTH_SANTA_BARBARA_COUNTY_REGIONAL_MLS";
        case Provider.PROVIDER_NORTHSTARMLS:
            return "PROVIDER_NORTHSTARMLS";
        case Provider.PROVIDER_NORTH_TEXAS_REAL_ESTATE_INFORMATION_SYSTEMS:
            return "PROVIDER_NORTH_TEXAS_REAL_ESTATE_INFORMATION_SYSTEMS";
        case Provider.PROVIDER_NORTHWEST_ARKANSAS_BOARD_OF_REALTORS:
            return "PROVIDER_NORTHWEST_ARKANSAS_BOARD_OF_REALTORS";
        case Provider.PROVIDER_NORTHWESTERN_WISCONSIN_MULTIPLE_LISTING_SERVICE:
            return "PROVIDER_NORTHWESTERN_WISCONSIN_MULTIPLE_LISTING_SERVICE";
        case Provider.PROVIDER_NORTHWEST_IOWA_MLS:
            return "PROVIDER_NORTHWEST_IOWA_MLS";
        case Provider.PROVIDER_NORTHWEST_MISSISSIPPI_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_NORTHWEST_MISSISSIPPI_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_NORTHWEST_MLS:
            return "PROVIDER_NORTHWEST_MLS";
        case Provider.PROVIDER_NORTHWEST_OHIO_REAL_ESTATE_INFORMATION_SYSTEMS:
            return "PROVIDER_NORTHWEST_OHIO_REAL_ESTATE_INFORMATION_SYSTEMS";
        case Provider.PROVIDER_NORTHWOODS_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_NORTHWOODS_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_OLD_KENTUCKY_HOME_BOARD_OF_REALTORS:
            return "PROVIDER_OLD_KENTUCKY_HOME_BOARD_OF_REALTORS";
        case Provider.PROVIDER_ONEKEY_MLS:
            return "PROVIDER_ONEKEY_MLS";
        case Provider.PROVIDER_OUTER_BANKS_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_OUTER_BANKS_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_OZARK_GATEWAY_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_OZARK_GATEWAY_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_PACIFIC_REGIONAL_MLS:
            return "PROVIDER_PACIFIC_REGIONAL_MLS";
        case Provider.PROVIDER_PAGE_LAKE_POWELL_MLS:
            return "PROVIDER_PAGE_LAKE_POWELL_MLS";
        case Provider.PROVIDER_PALESTINE_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_PALESTINE_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_PALM_BEACH_BOARD_OF_REALTORS:
            return "PROVIDER_PALM_BEACH_BOARD_OF_REALTORS";
        case Provider.PROVIDER_PALMETTO_MULTIPLE_LISTING_SERVICE:
            return "PROVIDER_PALMETTO_MULTIPLE_LISTING_SERVICE";
        case Provider.PROVIDER_PANAMA:
            return "PROVIDER_PANAMA";
        case Provider.PROVIDER_PARK_CITY_BOARD_OF_REALTORS:
            return "PROVIDER_PARK_CITY_BOARD_OF_REALTORS";
        case Provider.PROVIDER_PEARL_RIVER_COUNTY_BOARD_OF_REALTORS:
            return "PROVIDER_PEARL_RIVER_COUNTY_BOARD_OF_REALTORS";
        case Provider.PROVIDER_PENSACOLA_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_PENSACOLA_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_PERMIAN_BASIN_BOARD_OF_REALTORS:
            return "PROVIDER_PERMIAN_BASIN_BOARD_OF_REALTORS";
        case Provider.PROVIDER_PIKES_PEAK_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_PIKES_PEAK_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_PIKEWAYNE_ASSOCIATION_OF_REALTORS_MLS:
            return "PROVIDER_PIKEWAYNE_ASSOCIATION_OF_REALTORS_MLS";
        case Provider.PROVIDER_POCONO_MOUNTAINS_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_POCONO_MOUNTAINS_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_PORT_NECHES_PORT_ARTHUR_NEDERLAND_BOARD_OF_REALTORS_INC_MLS:
            return "PROVIDER_PORT_NECHES_PORT_ARTHUR_NEDERLAND_BOARD_OF_REALTORS_INC_MLS";
        case Provider.PROVIDER_PORTUGAL:
            return "PROVIDER_PORTUGAL";
        case Provider.PROVIDER_PRESCOTT_AREA_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_PRESCOTT_AREA_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_PRIMEMLS:
            return "PROVIDER_PRIMEMLS";
        case Provider.PROVIDER_PUEBLO_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_PUEBLO_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_PUERTO_RICO:
            return "PROVIDER_PUERTO_RICO";
        case Provider.PROVIDER_QAMLS2:
            return "PROVIDER_QAMLS2";
        case Provider.PROVIDER_QAMLS3:
            return "PROVIDER_QAMLS3";
        case Provider.PROVIDER_QAMLS4:
            return "PROVIDER_QAMLS4";
        case Provider.PROVIDER_RANDOLPH_COUNTY_BOARD_OF_REALTORS:
            return "PROVIDER_RANDOLPH_COUNTY_BOARD_OF_REALTORS";
        case Provider.PROVIDER_RANGE_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_RANGE_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_REALCOMP_LIMITED_II:
            return "PROVIDER_REALCOMP_LIMITED_II";
        case Provider.PROVIDER_REAL_ESTATE_INFORMATION_NETWORK_INC:
            return "PROVIDER_REAL_ESTATE_INFORMATION_NETWORK_INC";
        case Provider.PROVIDER_REALMLS:
            return "PROVIDER_REALMLS";
        case Provider.PROVIDER_REALTOR_ASSOCIATION_OF_ACADIANA:
            return "PROVIDER_REALTOR_ASSOCIATION_OF_ACADIANA";
        case Provider.PROVIDER_REALTOR_ASSOCIATION_OF_FRANKLIN_AND_GULF_COUNTIES:
            return "PROVIDER_REALTOR_ASSOCIATION_OF_FRANKLIN_AND_GULF_COUNTIES";
        case Provider.PROVIDER_REALTOR_ASSOCIATION_OF_NORTHEAST_WISCONSIN:
            return "PROVIDER_REALTOR_ASSOCIATION_OF_NORTHEAST_WISCONSIN";
        case Provider.PROVIDER_REALTOR_ASSOCIATION_OF_SOUTHERN_KENTUCKY_INC:
            return "PROVIDER_REALTOR_ASSOCIATION_OF_SOUTHERN_KENTUCKY_INC";
        case Provider.PROVIDER_REALTOR_ASSOCIATION_OF_SOUTHERN_MINNESOTA:
            return "PROVIDER_REALTOR_ASSOCIATION_OF_SOUTHERN_MINNESOTA";
        case Provider.PROVIDER_REALTOR_ASSOCIATION_OF_THE_SIOUX_EMPIRE_MLS:
            return "PROVIDER_REALTOR_ASSOCIATION_OF_THE_SIOUX_EMPIRE_MLS";
        case Provider.PROVIDER_REALTORS_ASSOCIATION_OF_CITRUS_COUNTY:
            return "PROVIDER_REALTORS_ASSOCIATION_OF_CITRUS_COUNTY";
        case Provider.PROVIDER_REALTORS_ASSOCIATION_OF_INDIAN_RIVER_COUNTY:
            return "PROVIDER_REALTORS_ASSOCIATION_OF_INDIAN_RIVER_COUNTY";
        case Provider.PROVIDER_REALTORS_ASSOCIATION_OF_MAUI_INC:
            return "PROVIDER_REALTORS_ASSOCIATION_OF_MAUI_INC";
        case Provider.PROVIDER_RECOLORADO:
            return "PROVIDER_RECOLORADO";
        case Provider.PROVIDER_REGIONAL_MULTIPLE_LISTING_SERVICES:
            return "PROVIDER_REGIONAL_MULTIPLE_LISTING_SERVICES";
        case Provider.PROVIDER_RIDGECREST_AREA_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_RIDGECREST_AREA_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_RIVER_COUNTIES_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_RIVER_COUNTIES_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_RMLS_ALLIANCE_LLC:
            return "PROVIDER_RMLS_ALLIANCE_LLC";
        case Provider.PROVIDER_ROANOKE_VALLEY_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_ROANOKE_VALLEY_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_ROCKFORD_AREA_MLS:
            return "PROVIDER_ROCKFORD_AREA_MLS";
        case Provider.PROVIDER_ROCKY_MOUNT_AREA_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_ROCKY_MOUNT_AREA_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_ROYAL_PALM_COAST_REALTOR_ASSOCIATION:
            return "PROVIDER_ROYAL_PALM_COAST_REALTOR_ASSOCIATION";
        case Provider.PROVIDER_RUIDOSOLINCOLN_COUNTY_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_RUIDOSOLINCOLN_COUNTY_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_RUSSELLVILLE_BOARD_OF_REALTORS:
            return "PROVIDER_RUSSELLVILLE_BOARD_OF_REALTORS";
        case Provider.PROVIDER_SAN_ANGELO_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_SAN_ANGELO_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_SAN_ANTONIO_BOARD_OF_REALTORS:
            return "PROVIDER_SAN_ANTONIO_BOARD_OF_REALTORS";
        case Provider.PROVIDER_SAN_DIEGO_MLS:
            return "PROVIDER_SAN_DIEGO_MLS";
        case Provider.PROVIDER_SAN_FRANCISCO_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_SAN_FRANCISCO_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_SAN_JUAN_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_SAN_JUAN_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_SANTA_BARBARA_MULTIPLE_LISTING_SERVICE:
            return "PROVIDER_SANTA_BARBARA_MULTIPLE_LISTING_SERVICE";
        case Provider.PROVIDER_SANTA_FE_ASSOCIATION_OF_REALTORS_INC:
            return "PROVIDER_SANTA_FE_ASSOCIATION_OF_REALTORS_INC";
        case Provider.PROVIDER_SAVANNAH_MULTILIST_CORPORATION:
            return "PROVIDER_SAVANNAH_MULTILIST_CORPORATION";
        case Provider.PROVIDER_SCIOTO_VALLEY_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_SCIOTO_VALLEY_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_SEDONA_VERDE_VALLEY_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_SEDONA_VERDE_VALLEY_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_SHASTA_MLS:
            return "PROVIDER_SHASTA_MLS";
        case Provider.PROVIDER_SMART_MLS:
            return "PROVIDER_SMART_MLS";
        case Provider.PROVIDER_SNAKE_RIVER_REGIONAL_MLS:
            return "PROVIDER_SNAKE_RIVER_REGIONAL_MLS";
        case Provider.PROVIDER_SOUTH_AFRICA:
            return "PROVIDER_SOUTH_AFRICA";
        case Provider.PROVIDER_SOUTH_BROWARD_BOARD_OF_REALTORS:
            return "PROVIDER_SOUTH_BROWARD_BOARD_OF_REALTORS";
        case Provider.PROVIDER_SOUTH_CENTRAL_ASSOCIATION_OF_REALTORS_MLS:
            return "PROVIDER_SOUTH_CENTRAL_ASSOCIATION_OF_REALTORS_MLS";
        case Provider.PROVIDER_SOUTH_CENTRAL_KANSAS_MLS:
            return "PROVIDER_SOUTH_CENTRAL_KANSAS_MLS";
        case Provider.PROVIDER_SOUTH_CENTRAL_WISCONSIN_MLS_CORPORATION:
            return "PROVIDER_SOUTH_CENTRAL_WISCONSIN_MLS_CORPORATION";
        case Provider.PROVIDER_SOUTHEAST_ALASKA_MLS:
            return "PROVIDER_SOUTHEAST_ALASKA_MLS";
        case Provider.PROVIDER_SOUTHEAST_KANSAS_MULTIPLE_LISTING_SYSTEM:
            return "PROVIDER_SOUTHEAST_KANSAS_MULTIPLE_LISTING_SYSTEM";
        case Provider.PROVIDER_SOUTHERN_INDIANA_REALTOR_ASSOCIATION:
            return "PROVIDER_SOUTHERN_INDIANA_REALTOR_ASSOCIATION";
        case Provider.PROVIDER_SOUTHERN_MISSOURI_REGIONAL_MLS_LLC:
            return "PROVIDER_SOUTHERN_MISSOURI_REGIONAL_MLS_LLC";
        case Provider.PROVIDER_SOUTHERN_NEW_MEXICO_MLS:
            return "PROVIDER_SOUTHERN_NEW_MEXICO_MLS";
        case Provider.PROVIDER_SOUTH_GEORGIA_MLS:
            return "PROVIDER_SOUTH_GEORGIA_MLS";
        case Provider.PROVIDER_SOUTH_JERSEY_SHORE_REGIONAL_MLS:
            return "PROVIDER_SOUTH_JERSEY_SHORE_REGIONAL_MLS";
        case Provider.PROVIDER_SOUTH_PADRE_ISLAND_BOARD_OF_REALTORS:
            return "PROVIDER_SOUTH_PADRE_ISLAND_BOARD_OF_REALTORS";
        case Provider.PROVIDER_SOUTHWEST_MLS:
            return "PROVIDER_SOUTHWEST_MLS";
        case Provider.PROVIDER_SOUTHWEST_VIRGINIA_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_SOUTHWEST_VIRGINIA_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_SPACE_COAST_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_SPACE_COAST_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_SPACE_COAST_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY:
            return "PROVIDER_SPACE_COAST_ASSOCIATION_OF_REALTORS_EXP_PORTAL_ONLY";
        case Provider.PROVIDER_SPAIN:
            return "PROVIDER_SPAIN";
        case Provider.PROVIDER_SPARTANBURG_ASSOCIATION_OF_REALTORS_INC:
            return "PROVIDER_SPARTANBURG_ASSOCIATION_OF_REALTORS_INC";
        case Provider.PROVIDER_SPOKANE_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_SPOKANE_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_STATEN_ISLAND_BOARD_OF_REALTORS:
            return "PROVIDER_STATEN_ISLAND_BOARD_OF_REALTORS";
        case Provider.PROVIDER_STATE_WIDE_MLS_OF_RHODE_ISLAND_INC:
            return "PROVIDER_STATE_WIDE_MLS_OF_RHODE_ISLAND_INC";
        case Provider.PROVIDER_ST_AUGUSTINE_ST_JOHNS_COUNTY_BOARD_OF_REALTORS:
            return "PROVIDER_ST_AUGUSTINE_ST_JOHNS_COUNTY_BOARD_OF_REALTORS";
        case Provider.PROVIDER_STILLWATER_BOARD_OF_REALTORS:
            return "PROVIDER_STILLWATER_BOARD_OF_REALTORS";
        case Provider.PROVIDER_STRATEGIC_MLS_ALLIANCE:
            return "PROVIDER_STRATEGIC_MLS_ALLIANCE";
        case Provider.PROVIDER_SUMMIT_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_SUMMIT_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_SUNFLOWER_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_SUNFLOWER_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_TAHOE_SIERRA_BOARD_OF_REALTORS:
            return "PROVIDER_TAHOE_SIERRA_BOARD_OF_REALTORS";
        case Provider.PROVIDER_TAOS_COUNTY_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_TAOS_COUNTY_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_TENNESSEE_VIRGINIA_REGIONAL_MULTIPLE_LISTING_SERVICE:
            return "PROVIDER_TENNESSEE_VIRGINIA_REGIONAL_MULTIPLE_LISTING_SERVICE";
        case Provider.PROVIDER_TETON_BOARD_OF_REALTORS:
            return "PROVIDER_TETON_BOARD_OF_REALTORS";
        case Provider.PROVIDER_TEXARKANA_BOARD_OF_REALTORS:
            return "PROVIDER_TEXARKANA_BOARD_OF_REALTORS";
        case Provider.PROVIDER_TILLAMOOK_COUNTY_BOARD_OF_REALTORS_MLS:
            return "PROVIDER_TILLAMOOK_COUNTY_BOARD_OF_REALTORS_MLS";
        case Provider.PROVIDER_TOPSAIL_ISLAND_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_TOPSAIL_ISLAND_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_TRIAD_MULTIPLE_LISTING_SERVICE:
            return "PROVIDER_TRIAD_MULTIPLE_LISTING_SERVICE";
        case Provider.PROVIDER_TRIANGLE_MLS:
            return "PROVIDER_TRIANGLE_MLS";
        case Provider.PROVIDER_TRINITY_COUNTY_MLS:
            return "PROVIDER_TRINITY_COUNTY_MLS";
        case Provider.PROVIDER_TULARE_COUNTY_MLS:
            return "PROVIDER_TULARE_COUNTY_MLS";
        case Provider.PROVIDER_TUOLUMNE_COUNTY_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_TUOLUMNE_COUNTY_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_ULSTER_COUNTY_BOARD_OF_REALTORS_MLS:
            return "PROVIDER_ULSTER_COUNTY_BOARD_OF_REALTORS_MLS";
        case Provider.PROVIDER_UPPER_CUMBERLAND_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_UPPER_CUMBERLAND_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_UPPER_PENINSULA_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_UPPER_PENINSULA_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_VAIL_BOARD_OF_REALTORS_MLS:
            return "PROVIDER_VAIL_BOARD_OF_REALTORS_MLS";
        case Provider.PROVIDER_VALLEY_MLS:
            return "PROVIDER_VALLEY_MLS";
        case Provider.PROVIDER_WACO_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_WACO_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_WASATCH_FRONT_REGIONAL_MLS:
            return "PROVIDER_WASATCH_FRONT_REGIONAL_MLS";
        case Provider.PROVIDER_WASHINGTON_BEAUFORT_COUNTY_BOARD_OF_REALTORS:
            return "PROVIDER_WASHINGTON_BEAUFORT_COUNTY_BOARD_OF_REALTORS";
        case Provider.PROVIDER_WASHINGTON_COUNTY_BOARD_OF_REALTORS:
            return "PROVIDER_WASHINGTON_COUNTY_BOARD_OF_REALTORS";
        case Provider.PROVIDER_WEST_ALABAMA_MULTIPLE_LISTING_SERVICE:
            return "PROVIDER_WEST_ALABAMA_MULTIPLE_LISTING_SERVICE";
        case Provider.PROVIDER_WEST_CENTRAL_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_WEST_CENTRAL_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_WESTCLIFFE_LISTING_SERVICE:
            return "PROVIDER_WESTCLIFFE_LISTING_SERVICE";
        case Provider.PROVIDER_WESTERN_ARIZONA_REALTOR_DATA_EXCHANGE:
            return "PROVIDER_WESTERN_ARIZONA_REALTOR_DATA_EXCHANGE";
        case Provider.PROVIDER_WESTERN_REGIONAL_INFORMATION_SYSTEMS_AND_TECHNOLOGY_INC:
            return "PROVIDER_WESTERN_REGIONAL_INFORMATION_SYSTEMS_AND_TECHNOLOGY_INC";
        case Provider.PROVIDER_WESTERN_UPSTATE_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_WESTERN_UPSTATE_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_WEST_PENN_MULTI_LIST:
            return "PROVIDER_WEST_PENN_MULTI_LIST";
        case Provider.PROVIDER_WHEELING_BOARD_OF_REALTORS:
            return "PROVIDER_WHEELING_BOARD_OF_REALTORS";
        case Provider.PROVIDER_WHITE_MOUNTAIN_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_WHITE_MOUNTAIN_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_WILLAMETTE_VALLEY_MULTIPLE_LISTING_SERVICE:
            return "PROVIDER_WILLAMETTE_VALLEY_MULTIPLE_LISTING_SERVICE";
        case Provider.PROVIDER_WILSON_BOARD_OF_REALTORS:
            return "PROVIDER_WILSON_BOARD_OF_REALTORS";
        case Provider.PROVIDER_WINNIPEG_REGIONAL_REAL_ESTATE_BOARD:
            return "PROVIDER_WINNIPEG_REGIONAL_REAL_ESTATE_BOARD";
        case Provider.PROVIDER_WYOMING_MLS:
            return "PROVIDER_WYOMING_MLS";
        case Provider.PROVIDER_YUMA_ASSOCIATION_OF_REALTORS:
            return "PROVIDER_YUMA_ASSOCIATION_OF_REALTORS";
        case Provider.PROVIDER_NORTH_CAROLINA_REGIONAL_MULTIPLE_LISTING_SERVICE:
            return "PROVIDER_NORTH_CAROLINA_REGIONAL_MULTIPLE_LISTING_SERVICE";
        case Provider.PROVIDER_AGENT_UPLOAD:
            return "PROVIDER_AGENT_UPLOAD";
        case Provider.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
//# sourceMappingURL=provider.js.map